//----------------------------------------------------------BINU



// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   TextField,
//   InputAdornment,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { fetchTodayAttendance } from "../actions/TodayAction";
// import { fetchJobs, fetchLocations, assignJob } from "../actions/AssignAction";
// const AssignJob = () => {
//   const dispatch = useDispatch();
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.todayAttendance || {}
//   );
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: jobAssignmentLoading, error } = useSelector(
//     (state) => state.assignJobpost || {}
//   );
//   const [selectedJob, setSelectedJob] = useState("");
//   const [selectedJobIwno, setSelectedJobIwno] = useState("");
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [searchQuery, setSearchQuery] = useState("");
//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};
//   const [selectedLocation, setSelectedLocation] = useState(role);

//   const handleJobChange = (event) => {
//     const selectedJob = event.target.value;
//     const selectedJobData = jobValue.find(
//       (job) => job.jobDescription === selectedJob
//     );
//     if (selectedJobData) {
//       setSelectedJob(selectedJob);
//       setSelectedJobIwno(selectedJobData.iwNo);
//     }
//   };

//   const handleLocationChange = (event) => {
//     setSelectedLocation(event.target.value);
//   };

//   const handleCheckboxChange = (id) => {
//     setSelectedAttendance((prev) => {
//       const updatedState = { ...prev, [id]: !prev[id] };
//       return updatedState;
//     });
//   };

//   const getTodayDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchTodayAttendance(date, department, selectedLocation));
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, selectedLocation, employeeId, department]);

//   const handleSubmit = () => {
//     const selectedEmpIds = Object.keys(selectedAttendance).filter(
//       (key) => selectedAttendance[key]
//     );
//     if (!selectedJob || !role || selectedEmpIds.length === 0) {
//       setSnackbarMessage(
//         "Please select a job, location, and at least one employee."
//       );
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }
//     const atttendJobList = selectedEmpIds.map((id) => ({
//       Id: id,
//       iwNo: selectedJobIwno,
//       supervisorserviceno: employeeId,
//     }));
//     const postData = {
//       atttendJobList: JSON.stringify(atttendJobList),
//       supervisor: employeeId,

//     };
//     dispatch(assignJob(postData));
//     setSelectedJob("");
//     setSelectedJobIwno("");
//     setSelectedLocation(role);
//     setSelectedAttendance({});
//     setSnackbarMessage("Job assigned successfully!");
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);
//   };

//   useEffect(() => {
//     if (jobAssignmentLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       }
//     }
//   }, [jobAssignmentLoading, error]);
//   // Filter attendance items based on search query
//   const filteredAttendanceItems = (attendanceItems || []).filter((item) =>
//     item?.serviceNo?.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />
//       {/* Search Bar */}
//       <Box sx={{ marginBottom: 2 }}>
//         <TextField
//           fullWidth
//           label="Search by Service Number"
//           variant="outlined"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: "#154C79" }} />{" "}
//                 {/* Add the search icon */}
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             color: "#154C79",
//             borderRadius: "20px",
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "20px",
//             },
//             "& .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#154C79",
//             },
//           }}
//         />
//       </Box>
//       {/* Location and Job Dropdowns */}
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         {/* Location Dropdown */}
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Location
//             </InputLabel>
//             <Select
//               value={selectedLocation}
//               onChange={handleLocationChange}
//               label="Location"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {locationLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 locationValue?.map((location, index) => (
//                   <MenuItem
//                     key={index}
//                     value={location.location}
//                     sx={{
//                       whiteSpace: "normal", // Ensures long text wraps within the dropdown
//                       wordWrap: "break-word", // Prevents overflow by wrapping long words
//                       padding: "8px 16px", // Adds padding for better spacing
//                       fontWeight: "400", // Adjusts font weight for clarity
//                       fontSize: "14px", // Sets a consistent font size
//                       lineHeight: "1.5", // Ensures good line height for readability
//                       overflow: "hidden", // Prevents overflow issues
//                       textOverflow: "ellipsis", // Adds ellipsis if text is too long
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)", // Adds hover effect for better interactivity
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)", // Changes selected background color
//                       },
//                     }}
//                   >
//                     {location.locationDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//         {/* Job Dropdown */}
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Job
//             </InputLabel>
//             <Select
//               value={selectedJob}
//               onChange={handleJobChange}
//               label="Job"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {jobLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 jobValue?.map((job, index) => (
//                   <MenuItem
//                     key={index}
//                     value={job.jobDescription}
//                     sx={{
//                       whiteSpace: "normal", // Ensures long text wraps within the dropdown
//                       wordWrap: "break-word", // Prevents overflow by wrapping long words
//                       padding: "8px 16px", // Adds padding for better spacing
//                       fontWeight: "400", // Adjusts font weight for clarity
//                       fontSize: "14px", // Sets a consistent font size
//                       lineHeight: "1.5", // Ensures good line height for readability
//                       overflow: "hidden", // Prevents overflow issues
//                       textOverflow: "ellipsis", // Adds ellipsis if text is too long
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)", // Adds hover effect for better interactivity
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)", // Changes selected background color
//                       },
//                     }}
//                   >
//                     {job.jobDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>
//       {/* Attendance List */}
//       <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
//         {loading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               marginTop: "20px",
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : filteredAttendanceItems && filteredAttendanceItems.length > 0 ? (
//           filteredAttendanceItems.map((item) => (
//             <Box
//               key={item.id}
//               sx={{
//                 padding: "15px",
//                 borderRadius: "10px",
//                 marginBottom: "10px",
//                 boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                 backgroundColor: "#fff",
//                 border: "1px solid #ddd",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src={`https://esystems.cdl.lk/backend-test/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
//                 alt={item.EmpName}
//                 style={{
//                   width: "50px",
//                   height: "50px",
//                   borderRadius: "50%",
//                   objectFit: "cover",
//                   border: "2px solid #ddd",
//                   marginRight: "15px",
//                 }}
//                 onError={(e) => (e.target.src = "/placeholder-image.jpg")}
//               />
//               <Box sx={{ flexGrow: 1, marginLeft: 1 }}>
//                 <Typography
//                   sx={{
//                     fontWeight: "bold",
//                     color: "#121212",
//                     fontSize: "14px",
//                     marginRight: "15px",
//                   }}
//                 >
//                   {item.EmpName}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontWeight: "bold",
//                     color: "#121212",
//                     fontSize: "14px",
//                   }}
//                 >
//                   {item.serviceNo}
//                 </Typography>
//               </Box>
//               <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
//                 <Typography
//                   sx={{
//                     color: "#239B56",
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                   }}
//                 >
//                   {item.inTime || "N/A"}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     color: "#E74C3C",
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                   }}
//                 >
//                   {item.outTime || "N/A"}
//                 </Typography>
//               </Box>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     sx={{ flexGrow: 0, marginLeft: 3 }}
//                     checked={!!selectedAttendance[item.id]}
//                     onChange={() => handleCheckboxChange(item.id)}
//                   />
//                 }
//                 label=""
//               />
//             </Box>
//           ))
//         ) : (
//           <Typography
//             variant="body1"
//             sx={{ textAlign: "center", padding: "20px" }}
//           > No attendance data available.
//           </Typography>
//         )}

//       </Box>
//       {/* Submit Button */}
//       <Box
//         sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
//       >
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           sx={{
//             backgroundColor: "#142C54",
//             color: "#fff",
//             fontSize: "1rem",
//             borderRadius: "10px",
//             padding: "10px 20px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//             "&:hover": {
//               backgroundColor: "#0E3C59",
//             },
//           }}
//         >
//           Assign Job
//         </Button>
//       </Box>
//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };
// export default AssignJob;







//-------------------SACHITH




// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   TextField,
//   InputAdornment,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { fetchTodayAttendance } from "../actions/TodayAction";
// import { fetchJobs, fetchLocations, assignJob } from "../actions/AssignAction";

// const AssignJob = () => {
//   const dispatch = useDispatch();
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.todayAttendance || {}
//   );
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: jobAssignmentLoading, error } = useSelector(
//     (state) => state.assignJobpost || {}
//   );
//   const [selectedJob, setSelectedJob] = useState("");
//   const [selectedJobIwno, setSelectedJobIwno] = useState("");
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [searchQuery, setSearchQuery] = useState("");
//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};
//   const [selectedLocation, setSelectedLocation] = useState(role);

//   // Helper function to check if an employee is already assigned to any job
//   const isEmployeeAssigned = (employeeIwNo) => {
//     if (!jobValue || !employeeIwNo || employeeIwNo === 0) return false;
//     return jobValue.some(job => job.iwNo === employeeIwNo.toString());
//   };

//   // Helper function to get all assigned iwNo values
//   const getAssignedIwNos = () => {
//     if (!jobValue) return [];
//     return jobValue.map(job => job.iwNo).filter(iwNo => iwNo && iwNo !== "0");
//   };

//   const handleJobChange = (event) => {
//     const selectedJob = event.target.value;
//     const selectedJobData = jobValue.find(
//       (job) => job.jobDescription === selectedJob
//     );
//     if (selectedJobData) {
//       setSelectedJob(selectedJob);
//       setSelectedJobIwno(selectedJobData.iwNo);
//     }
//   };

//   const handleLocationChange = (event) => {
//     setSelectedLocation(event.target.value);
//   };

//   const handleCheckboxChange = (id, employeeIwNo) => {

//     if (isEmployeeAssigned(employeeIwNo)) {
//       setSnackbarMessage("This employee is already assigned to a job and cannot be unselected.");
//       setSnackbarSeverity("warning");
//       setSnackbarOpen(true);
//       return;
//     }

//     setSelectedAttendance((prev) => {
//       const updatedState = { ...prev, [id]: !prev[id] };
//       return updatedState;
//     });
//   };

//   const getTodayDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchTodayAttendance(date, department, selectedLocation));
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, selectedLocation, employeeId, department]);

//   // Update selectedAttendance when attendance or job data changes
//   useEffect(() => {
//     if (attendanceItems && jobValue) {
//       const updatedSelectedAttendance = {};

//       attendanceItems.forEach(item => {
//         if (isEmployeeAssigned(item.iwNo)) {
//           updatedSelectedAttendance[item.id] = true;
//         }
//       });

//       setSelectedAttendance(prev => ({
//         ...prev,
//         ...updatedSelectedAttendance
//       }));
//     }
//   }, [attendanceItems, jobValue]);

//   const handleSubmit = () => {
//     const selectedEmpIds = Object.keys(selectedAttendance).filter(
//       (key) => selectedAttendance[key]
//     );

//     // Filter out employees who are already assigned
//     const unassignedSelectedEmpIds = selectedEmpIds.filter(id => {
//       const employee = attendanceItems.find(item => item.id.toString() === id);
//       return employee && !isEmployeeAssigned(employee.iwNo);
//     });

//     if (!selectedJob || !role || unassignedSelectedEmpIds.length === 0) {
//       setSnackbarMessage(
//         "Please select a job, location, and at least one unassigned employee."
//       );
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }

//     const atttendJobList = unassignedSelectedEmpIds.map((id) => ({
//       Id: id,
//       iwNo: selectedJobIwno,
//       supervisorserviceno: employeeId,
//     }));

//     const postData = {
//       atttendJobList: JSON.stringify(atttendJobList),
//       supervisor: employeeId,
//     };

//     dispatch(assignJob(postData));

//     // Only clear selections for unassigned employees
//     setSelectedAttendance(prev => {
//       const updated = { ...prev };
//       unassignedSelectedEmpIds.forEach(id => {
//         delete updated[id];
//       });
//       return updated;
//     });

//     setSelectedJob("");
//     setSelectedJobIwno("");
//     setSelectedLocation(role);
//     setSnackbarMessage("Job assigned successfully!");
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);
//   };

//   useEffect(() => {
//     if (jobAssignmentLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       } else {
//         // Refresh data after successful assignment
//         const date = getTodayDate();
//         dispatch(fetchTodayAttendance(date, department, selectedLocation));
//         dispatch(fetchJobs(date, employeeId));
//       }
//     }
//   }, [jobAssignmentLoading, error, dispatch, department, selectedLocation, employeeId]);

//   // Filter attendance items based on search query
//   const filteredAttendanceItems = (attendanceItems || []).filter((item) =>
//     item?.serviceNo?.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />
//       {/* Search Bar */}
//       <Box sx={{ marginBottom: 2 }}>
//         <TextField
//           fullWidth
//           label="Search by Service Number"
//           variant="outlined"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: "#154C79" }} />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             color: "#154C79",
//             borderRadius: "20px",
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "20px",
//             },
//             "& .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#154C79",
//             },
//           }}
//         />
//       </Box>
//       {/* Location and Job Dropdowns */}
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         {/* Location Dropdown */}
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Location
//             </InputLabel>
//             <Select
//               value={selectedLocation}
//               onChange={handleLocationChange}
//               label="Location"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {locationLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 locationValue?.map((location, index) => (
//                   <MenuItem
//                     key={index}
//                     value={location.location}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {location.locationDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//         {/* Job Dropdown */}
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Job
//             </InputLabel>
//             <Select
//               value={selectedJob}
//               onChange={handleJobChange}
//               label="Job"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {jobLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 jobValue?.map((job, index) => (
//                   <MenuItem
//                     key={index}
//                     value={job.jobDescription}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {job.jobDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>
//       {/* Attendance List */}
//       <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
//         {loading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               marginTop: "20px",
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : filteredAttendanceItems && filteredAttendanceItems.length > 0 ? (
//           filteredAttendanceItems.map((item) => {
//             const isAssigned = isEmployeeAssigned(item.iwNo);
//             return (
//               <Box
//                 key={item.id}
//                 sx={{
//                   padding: "15px",
//                   borderRadius: "10px",
//                   marginBottom: "10px",
//                   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                   backgroundColor: isAssigned ? "#f0f8ff" : "#fff",
//                   border: isAssigned ? "2px solid #4CAF50" : "1px solid #ddd",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   opacity: isAssigned ? 0.8 : 1,
//                 }}
//               >
//                 <img
//                   src={`https://esystems.cdl.lk/backend-test/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
//                   alt={item.EmpName}
//                   style={{
//                     width: "50px",
//                     height: "50px",
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                     border: "2px solid #ddd",
//                     marginRight: "15px",
//                   }}
//                   onError={(e) => (e.target.src = "/placeholder-image.jpg")}
//                 />
//                 <Box sx={{ flexGrow: 1, marginLeft: 1 }}>
//                   <Typography
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#121212",
//                       fontSize: "14px",
//                       marginRight: "15px",
//                     }}
//                   >
//                     {item.EmpName}
//                     {isAssigned && (
//                       <Typography
//                         component="span"
//                         sx={{
//                           color: "#4CAF50",
//                           fontSize: "12px",
//                           fontWeight: "normal",
//                           marginLeft: "10px",
//                         }}
//                       >
//                         (Already Assigned)
//                       </Typography>
//                     )}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#121212",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.serviceNo}
//                   </Typography>
//                 </Box>
//                 <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
//                   <Typography
//                     sx={{
//                       color: "#239B56",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.inTime || "N/A"}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       color: "#E74C3C",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.outTime || "N/A"}
//                   </Typography>
//                 </Box>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       sx={{ flexGrow: 0, marginLeft: 3 }}
//                       checked={!!selectedAttendance[item.id]}
//                       onChange={() => handleCheckboxChange(item.id, item.iwNo)}
//                       disabled={isAssigned}
//                     />
//                   }
//                   label=""
//                 />
//               </Box>
//             );
//           })
//         ) : (
//           <Typography
//             variant="body1"
//             sx={{ textAlign: "center", padding: "20px" }}
//           >
//             No attendance data available.
//           </Typography>
//         )}
//       </Box>
//       {/* Submit Button */}
//       <Box
//         sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
//       >
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           sx={{
//             backgroundColor: "#142C54",
//             color: "#fff",
//             fontSize: "1rem",
//             borderRadius: "10px",
//             padding: "10px 20px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//             "&:hover": {
//               backgroundColor: "#0E3C59",
//             },
//           }}
//         >
//           Assign Job
//         </Button>
//       </Box>
//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity} 
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AssignJob;






//-------------------------------------------------------------------------Modify------------------------------------------------------


// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   TextField,
//   InputAdornment,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { fetchTodayAttendance } from "../actions/TodayAction";
// import { fetchJobs, fetchLocations, assignJob } from "../actions/AssignAction";

// const AssignJob = () => {
//   const dispatch = useDispatch();
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.todayAttendance || {}
//   );
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: jobAssignmentLoading, error } = useSelector(
//     (state) => state.assignJobpost || {}
//   );
//   const [selectedJob, setSelectedJob] = useState("");
//   const [selectedJobIwno, setSelectedJobIwno] = useState("");
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [searchQuery, setSearchQuery] = useState("");
//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};
//   const [selectedLocation, setSelectedLocation] = useState(role);

//   // Helper function to check if an employee is already assigned to any job
//   const isEmployeeAssigned = (employeeIwNo) => {
//     if (!jobValue || !employeeIwNo || employeeIwNo === 0) return false;
//     return jobValue.some(job => job.iwNo === employeeIwNo.toString());
//   };

//   // Helper function to check if an employee is assigned to the currently selected job
//   const isEmployeeAssignedToSelectedJob = (employeeIwNo) => {
//     if (!jobValue || !employeeIwNo || employeeIwNo === 0 || !selectedJobIwno) return false;
//     return jobValue.some(job => job.iwNo === employeeIwNo.toString() && job.iwNo === selectedJobIwno);
//   };

//   // Helper function to get all assigned iwNo values
//   const getAssignedIwNos = () => {
//     if (!jobValue) return [];
//     return jobValue.map(job => job.iwNo).filter(iwNo => iwNo && iwNo !== "0");
//   };

//   const handleJobChange = (event) => {
//     const selectedJob = event.target.value;
//     const selectedJobData = jobValue.find(
//       (job) => job.jobDescription === selectedJob
//     );
//     if (selectedJobData) {
//       setSelectedJob(selectedJob);
//       setSelectedJobIwno(selectedJobData.iwNo);
//     } else {
//       setSelectedJob("");
//       setSelectedJobIwno("");
//     }
//   };

//   const handleLocationChange = (event) => {
//     setSelectedLocation(event.target.value);
//   };

//   const handleCheckboxChange = (id, employeeIwNo) => {
//     // Check if employee is assigned to a different job (not the currently selected one)
//     const isAssignedToAnotherJob = isEmployeeAssigned(employeeIwNo) && !isEmployeeAssignedToSelectedJob(employeeIwNo);

//     if (isAssignedToAnotherJob) {
//       setSnackbarMessage("This employee is already assigned to a different job and cannot be selected.");
//       setSnackbarSeverity("warning");
//       setSnackbarOpen(true);
//       return;
//     }

//     setSelectedAttendance((prev) => {
//       const updatedState = { ...prev, [id]: !prev[id] };
//       return updatedState;
//     });
//   };

//   const getTodayDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchTodayAttendance(date, department, selectedLocation));
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, selectedLocation, employeeId, department]);

//   // Update selectedAttendance when job selection changes
//   useEffect(() => {
//     if (attendanceItems && jobValue && selectedJobIwno) {
//       const updatedSelectedAttendance = {};

//       attendanceItems.forEach(item => {
//         if (isEmployeeAssignedToSelectedJob(item.iwNo)) {
//           updatedSelectedAttendance[item.id] = true;
//         }
//       });

//       setSelectedAttendance(updatedSelectedAttendance);
//     } else if (!selectedJobIwno) {
//       // Clear all selections when no job is selected
//       setSelectedAttendance({});
//     }
//   }, [attendanceItems, jobValue, selectedJobIwno]);

//   const handleSubmit = () => {
//     const selectedEmpIds = Object.keys(selectedAttendance).filter(
//       (key) => selectedAttendance[key]
//     );

//     // Filter out employees who are already assigned to other jobs
//     const unassignedSelectedEmpIds = selectedEmpIds.filter(id => {
//       const employee = attendanceItems.find(item => item.id.toString() === id);
//       return employee && (!isEmployeeAssigned(employee.iwNo) || isEmployeeAssignedToSelectedJob(employee.iwNo));
//     });

//     if (!selectedJob || !role || unassignedSelectedEmpIds.length === 0) {
//       setSnackbarMessage(
//         "Please select a job, location, and at least one employee."
//       );
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }

//     const atttendJobList = unassignedSelectedEmpIds.map((id) => ({
//       Id: id,
//       iwNo: selectedJobIwno,
//       supervisorserviceno: employeeId,
//     }));

//     const postData = {
//       atttendJobList: JSON.stringify(atttendJobList),
//       supervisor: employeeId,
//     };

//     dispatch(assignJob(postData));

//     // Clear selections after assignment
//     setSelectedAttendance({});
//     setSelectedJob("");
//     setSelectedJobIwno("");
//     setSelectedLocation(role);
//     setSnackbarMessage("Job assigned successfully!");
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);
//   };

//   useEffect(() => {
//     if (jobAssignmentLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       } else {
//         // Refresh data after successful assignment
//         const date = getTodayDate();
//         dispatch(fetchTodayAttendance(date, department, selectedLocation));
//         dispatch(fetchJobs(date, employeeId));
//       }
//     }
//   }, [jobAssignmentLoading, error, dispatch, department, selectedLocation, employeeId]);

//   // Filter attendance items based on search query
//   const filteredAttendanceItems = (attendanceItems || []).filter((item) =>
//     item?.serviceNo?.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />
//       {/* Search Bar */}
//       <Box sx={{ marginBottom: 2 }}>
//         <TextField
//           fullWidth
//           label="Search by Service Number"
//           variant="outlined"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: "#154C79" }} />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             color: "#154C79",
//             borderRadius: "20px",
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "20px",
//             },
//             "& .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#154C79",
//             },
//           }}
//         />
//       </Box>
//       {/* Location and Job Dropdowns */}
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         {/* Location Dropdown */}
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Location
//             </InputLabel>
//             <Select
//               value={selectedLocation}
//               onChange={handleLocationChange}
//               label="Location"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {locationLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 locationValue?.map((location, index) => (
//                   <MenuItem
//                     key={index}
//                     value={location.location}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {location.locationDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//         {/* Job Dropdown */}
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Job
//             </InputLabel>
//             <Select
//               value={selectedJob}
//               onChange={handleJobChange}
//               label="Job"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {jobLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 jobValue?.map((job, index) => (
//                   <MenuItem
//                     key={index}
//                     value={job.jobDescription}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {job.jobDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>
//       {/* Attendance List */}
//       <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
//         {loading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               marginTop: "20px",
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : filteredAttendanceItems && filteredAttendanceItems.length > 0 ? (
//           filteredAttendanceItems.map((item) => {
//             const isAssignedToSelectedJob = isEmployeeAssignedToSelectedJob(item.iwNo);
//             const isAssignedToAnotherJob = isEmployeeAssigned(item.iwNo) && !isAssignedToSelectedJob;

//             return (
//               <Box
//                 key={item.id}
//                 sx={{
//                   padding: "15px",
//                   borderRadius: "10px",
//                   marginBottom: "10px",
//                   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                   backgroundColor: isAssignedToSelectedJob ? "#e8f5e8" :
//                     isAssignedToAnotherJob ? "#f0f8ff" : "#fff",
//                   border: isAssignedToSelectedJob ? "2px solid #4CAF50" :
//                     isAssignedToAnotherJob ? "2px solid #FFA500" : "1px solid #ddd",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   opacity: isAssignedToAnotherJob ? 0.6 : 1,
//                 }}
//               >
//                 <img
//                   src={`https://esystems.cdl.lk/backend-test/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
//                   alt={item.EmpName}
//                   style={{
//                     width: "50px",
//                     height: "50px",
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                     border: "2px solid #ddd",
//                     marginRight: "15px",
//                   }}
//                   onError={(e) => (e.target.src = "/placeholder-image.jpg")}
//                 />
                 
//                 <Box sx={{ flexGrow: 1, marginLeft: 1 }}>

//                   <Typography
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#121212",
//                       fontSize: "14px",
//                       marginRight: "10px",
//                     }}
//                   >
//                     {item.EmpName}
//                   </Typography>

                   
//                   {isAssignedToSelectedJob && (
//                     <Typography
//                       sx={{
//                         color: "#4CAF50",
//                         fontSize: "12px",
//                         fontWeight: "normal",
//                         marginLeft: "10px",
//                       }}
//                     >
//                       (Assigned to Job)
//                     </Typography>
//                   )}
//                   {isAssignedToAnotherJob && (
//                     <Typography
//                       sx={{
//                         color: "#FFA500",
//                         fontSize: "12px",
//                         fontWeight: "normal",
//                         marginLeft: "10px",
//                       }}
//                     >
//                       (Assigned to Job)
//                     </Typography>
//                   )}

                   
//                   <Typography
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#121212",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.serviceNo}
//                   </Typography>
//                 </Box>

//                 <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
//                   <Typography
//                     sx={{
//                       color: "#239B56",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.inTime || "N/A"}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       color: "#E74C3C",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.outTime || "N/A"}
//                   </Typography>
//                 </Box>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       sx={{ flexGrow: 0, marginLeft: 3 }}
//                       checked={!!selectedAttendance[item.id]}
//                       onChange={() => handleCheckboxChange(item.id, item.iwNo)}
//                       disabled={isAssignedToAnotherJob}
//                     />
//                   }
//                   label=""
//                 />
//               </Box>
//             );
//           })
//         ) : (
//           <Typography
//             variant="body1"
//             sx={{ textAlign: "center", padding: "20px" }}
//           >
//             No attendance data available.
//           </Typography>
//         )}
//       </Box>
//       {/* Submit Button */}
//       <Box
//         sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
//       >
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           sx={{
//             backgroundColor: "#142C54",
//             color: "#fff",
//             fontSize: "1rem",
//             borderRadius: "10px",
//             padding: "10px 20px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//             "&:hover": {
//               backgroundColor: "#0E3C59",
//             },
//           }}
//         >
//           Assign Job
//         </Button>
//       </Box>
//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AssignJob;





//-------------------------------------------------------------------------2025-12-29*-----------------------------------------------------
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   TextField,
//   InputAdornment,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { fetchTodayAttendance } from "../actions/TodayAction";
// import { fetchJobs, fetchLocations, assignJob } from "../actions/AssignAction";

// const AssignJob = () => {
//   const dispatch = useDispatch();
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.todayAttendance || {}
//   );
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: jobAssignmentLoading, error } = useSelector(
//     (state) => state.assignJobpost || {}
//   );
//   const [selectedJob, setSelectedJob] = useState("");
//   const [selectedJobIwno, setSelectedJobIwno] = useState("");
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [searchQuery, setSearchQuery] = useState("");
//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};
//   const [selectedLocation, setSelectedLocation] = useState(role);

   
//   const getEmployeeJob = (employeeIwNo) => {
//     if (!jobValue || !employeeIwNo || employeeIwNo === 0) return null;
//     return jobValue.find(job => job.iwNo === employeeIwNo.toString());
//   };

   
//   const isEmployeeAssignedToSelectedJob = (employeeIwNo) => {
//     if (!employeeIwNo || employeeIwNo === 0 || !selectedJobIwno) return false;
//     const assignedJob = getEmployeeJob(employeeIwNo);
//     return assignedJob && assignedJob.iwNo === selectedJobIwno;
//   };

  
//   const isEmployeeAssignedToAnyJob = (employeeIwNo) => {
//     if (!employeeIwNo || employeeIwNo === 0) return false;
//     return !!getEmployeeJob(employeeIwNo);
//   };

//   const handleJobChange = (event) => {
//     const selectedJob = event.target.value;
//     const selectedJobData = jobValue.find(
//       (job) => job.jobDescription === selectedJob
//     );
//     if (selectedJobData) {
//       setSelectedJob(selectedJob);
//       setSelectedJobIwno(selectedJobData.iwNo);
//     } else {
//       setSelectedJob("");
//       setSelectedJobIwno("");
//     }
//   };

//   const handleLocationChange = (event) => {
//     setSelectedLocation(event.target.value);
//   };

//   const handleCheckboxChange = (id, employeeIwNo) => {
//     setSelectedAttendance((prev) => {
//       const updatedState = { ...prev, [id]: !prev[id] };
//       return updatedState;
//     });
//   };

//   const getTodayDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchTodayAttendance(date, department, selectedLocation));
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, selectedLocation, employeeId, department]);

   
//   useEffect(() => {
//     if (attendanceItems) {
//       const updatedSelectedAttendance = {};

//       attendanceItems.forEach(item => {
         
//         const isAssigned = isEmployeeAssignedToAnyJob(item.iwNo);
//         updatedSelectedAttendance[item.id] = isAssigned;
//       });

//       setSelectedAttendance(updatedSelectedAttendance);
//     }
//   }, [attendanceItems, jobValue]);


  
//   const handleSubmit = () => {
//     const selectedEmpIds = Object.keys(selectedAttendance).filter(
//       (key) => selectedAttendance[key]
//     );

//     if (!selectedJob || !role || selectedEmpIds.length === 0) {
//       setSnackbarMessage(
//         "Please select a job, location, and at least one employee."
//       );
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }

//     const atttendJobList = selectedEmpIds.map((id) => ({
//       Id: id,
//       iwNo: selectedJobIwno,
//       supervisorserviceno: employeeId,
//     }));

//     const postData = {
//       atttendJobList: JSON.stringify(atttendJobList),
//       supervisor: employeeId,
//     };

//     dispatch(assignJob(postData));

//     setSnackbarMessage("Job assigned successfully!");
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);
//   };

//   useEffect(() => {
//     if (jobAssignmentLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       } else {
         
//         const date = getTodayDate();
//         dispatch(fetchTodayAttendance(date, department, selectedLocation));
//         dispatch(fetchJobs(date, employeeId));
//       }
//     }
//   }, [jobAssignmentLoading, error, dispatch, department, selectedLocation, employeeId]);

   
//   const filteredAttendanceItems = (attendanceItems || []).filter((item) =>
//     item?.serviceNo?.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />
//       {/* Search Bar */}
//       <Box sx={{ marginBottom: 2 }}>
//         <TextField
//           fullWidth
//           label="Search by Service Number"
//           variant="outlined"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: "#154C79" }} />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             color: "#154C79",
//             borderRadius: "20px",
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "20px",
//             },
//             "& .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#154C79",
//             },
//           }}
//         />
//       </Box>
//       {/* Location and Job Dropdowns */}
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         {/* Location Dropdown */}
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Location
//             </InputLabel>
//             <Select
//               value={selectedLocation}
//               onChange={handleLocationChange}
//               label="Location"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {locationLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 locationValue?.map((location, index) => (
//                   <MenuItem
//                     key={index}
//                     value={location.location}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {location.locationDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//         {/* Job Dropdown */}
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Job
//             </InputLabel>
//             <Select
//               value={selectedJob}
//               onChange={handleJobChange}
//               label="Job"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {jobLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 jobValue?.map((job, index) => (
//                   <MenuItem
//                     key={index}
//                     value={job.jobDescription}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {job.jobDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>
//       {/* Attendance List */}
//       <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
//         {loading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               marginTop: "20px",
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : filteredAttendanceItems && filteredAttendanceItems.length > 0 ? (
//           filteredAttendanceItems.map((item) => {
//             const assignedJob = getEmployeeJob(item.iwNo);
//             const isAssignedToSelectedJob = isEmployeeAssignedToSelectedJob(item.iwNo);
//             const isAssignedToOtherJob = assignedJob && !isAssignedToSelectedJob;
//             const isAssignedToAnyJob = isAssignedToSelectedJob || isAssignedToOtherJob;

//             return (
//               <Box
//                 key={item.id}
//                 sx={{
//                   padding: "15px",
//                   borderRadius: "10px",
//                   marginBottom: "10px",
//                   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                   backgroundColor: isAssignedToSelectedJob ? "#e8f5e8" :
//                     isAssignedToOtherJob ? "#fff3e0" : "#fff",
//                   border: isAssignedToSelectedJob ? "2px solid #4CAF50" :
//                     isAssignedToOtherJob ? "2px solid #FFA500" : "1px solid #ddd",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                 }}
//               >
//                 <img
//                   //src={`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
//                   alt={item.EmpName}
//                   style={{
//                     width: "50px",
//                     height: "50px",
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                     border: "2px solid #ddd",
//                     marginRight: "15px",
//                   }}
//                   onError={(e) => (e.target.src = "/placeholder-image.jpg")}
//                 />
                 
//                 <Box sx={{ flexGrow: 1, marginLeft: 1 }}>
//                   <Typography
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#121212",
//                       fontSize: "14px",
//                       marginRight: "10px",
//                     }}
//                   >
//                     {item.EmpName}
//                   </Typography>

//                   {isAssignedToSelectedJob && (
//                     <Typography
//                       sx={{
//                         color: "#4CAF50",
//                         fontSize: "12px",
//                         fontWeight: "normal",
//                       }}
//                     >
//                       (Assigned to this job)
//                     </Typography>
//                   )}
//                   {isAssignedToOtherJob && (
//                     <Typography
//                       sx={{
//                         color: "#FFA500",
//                         fontSize: "12px",
//                         fontWeight: "normal",
//                       }}
//                     >
//                       (Assigned to: {assignedJob.jobDescription})
//                     </Typography>
//                   )}

//                   <Typography
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#121212",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.serviceNo}
//                   </Typography>
//                 </Box>

//                 <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
//                   <Typography
//                     sx={{
//                       color: "#239B56",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.inTime || "N/A"}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       color: "#E74C3C",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.outTime || "N/A"}
//                   </Typography>
//                 </Box>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       sx={{ flexGrow: 0, marginLeft: 3 }}
//                       checked={!!selectedAttendance[item.id]}
//                       onChange={() => handleCheckboxChange(item.id, item.iwNo)}
//                       color={isAssignedToOtherJob ? "warning" : "primary"}
//                     />
//                   }
//                   label=""
//                 />
//               </Box>
//             );
//           })
//         ) : (
//           <Typography
//             variant="body1"
//             sx={{ textAlign: "center", padding: "20px" }}
//           >
//             No attendance data available.
//           </Typography>
//         )}
//       </Box>
//       {/* Submit Button */}
//       <Box
//         sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
//       >
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           sx={{
//             backgroundColor: "#142C54",
//             color: "#fff",
//             fontSize: "1rem",
//             borderRadius: "10px",
//             padding: "10px 20px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//             "&:hover": {
//               backgroundColor: "#0E3C59",
//             },
//           }}
//         >
//           Assign Job
//         </Button>
//       </Box>
//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AssignJob;












// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   TextField,
//   InputAdornment,
//   Chip,
//   ToggleButton,
//   ToggleButtonGroup,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { fetchTodayAttendance } from "../actions/TodayAction";
// import { fetchJobs, fetchLocations, assignJob } from "../actions/AssignAction";

// const AssignJob = () => {
//   const dispatch = useDispatch();
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.todayAttendance || {}
//   );
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: jobAssignmentLoading, error } = useSelector(
//     (state) => state.assignJobpost || {}
//   );
  
//   const [selectedJob, setSelectedJob] = useState("");
//   const [selectedJobIwno, setSelectedJobIwno] = useState("");
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [viewMode, setViewMode] = useState("unassigned"); 
//   const [initialLoad, setInitialLoad] = useState(true);
  
//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};
//   const [selectedLocation, setSelectedLocation] = useState(role);

//   const isEmployeeAssignedToAnyJob = (employeeIwNo) => {
//     if (!employeeIwNo || employeeIwNo === 0) return false;
//     return !!getEmployeeJob(employeeIwNo);
//   };

//   const getEmployeeJob = (employeeIwNo) => {
//     if (!jobValue || !employeeIwNo || employeeIwNo === 0) return null;
//     return jobValue.find(job => job.iwNo === employeeIwNo.toString());
//   };

//   const isEmployeeAssignedToSelectedJob = (employeeIwNo) => {
//     if (!employeeIwNo || !selectedJobIwno) return false;
//     const job = getEmployeeJob(employeeIwNo);
//     return job?.iwNo === selectedJobIwno;
//   };

//   const isEmployeeAssignedToOtherJob = (employeeIwNo) => {
//     if (!employeeIwNo || !selectedJobIwno) return false;
//     const job = getEmployeeJob(employeeIwNo);
//     return job && job.iwNo !== selectedJobIwno;
//   };
  
//   const filterEmployeesByJob = (employee) => {
//     switch (viewMode) {
//       case 'selected-job':
//         return selectedJobIwno && isEmployeeAssignedToSelectedJob(employee.iwNo);
//       case 'unassigned':
//         return !isEmployeeAssignedToAnyJob(employee.iwNo);
//       case 'all':
//       default:
//         return true;
//     }
//   };

//   const handleJobChange = (event) => {
//     const value = event.target.value;

//     if (!value) {
//       setSelectedJob("");
//       setSelectedJobIwno("");
//       // Clear all checkboxes when no job is selected
//       setSelectedAttendance({});
//       return;
//     }

//     const job = jobValue.find(j => j.jobDescription === value);
//     if (!job) return;

//     const previousJobIwno = selectedJobIwno;
//     setSelectedJob(value);
//     setSelectedJobIwno(job.iwNo);

//     // If changing to a different job, clear all checkboxes first
//     if (previousJobIwno && previousJobIwno !== job.iwNo) {
//       setSelectedAttendance({});
      
//       // Then set checkboxes for employees assigned to the new job
//       const updated = {};
//       attendanceItems?.forEach(item => {
//         updated[item.id] = isEmployeeAssignedToSelectedJob(item.iwNo);
//       });
//       setSelectedAttendance(updated);
//     } else {
//       // If it's the first job selection or same job, just set checkboxes for assigned employees
//       const updated = {};
//       attendanceItems?.forEach(item => {
//         updated[item.id] = isEmployeeAssignedToSelectedJob(item.iwNo);
//       });
//       setSelectedAttendance(updated);
//     }
//   };

//   const handleLocationChange = (event) => {
//     setSelectedLocation(event.target.value);
//   };

//   const handleCheckboxChange = (id, iwNo) => {
//     // In unassigned view, prevent selection of assigned employees
//     if (viewMode === "unassigned") {
//       const isAssigned = isEmployeeAssignedToAnyJob(iwNo);
//       if (isAssigned) {
//         setSnackbarMessage("This employee is already assigned to a job. Switch to 'All Employees' view to reassign.");
//         setSnackbarSeverity("warning");
//         setSnackbarOpen(true);
//         return;
//       }
//     }
    
//     // If no job is selected and trying to check an employee
//     if (!selectedJobIwno) {
//       setSelectedAttendance(prev => ({
//         ...prev,
//         [id]: !prev[id],
//       }));
//       return;
//     }
    
//     // Original logic for other views
//     if (isEmployeeAssignedToOtherJob(iwNo)) {
//       const confirm = window.confirm(
//         `This employee is assigned to "${getEmployeeJob(iwNo)?.jobDescription}". Reassign?`
//       );
//       if (!confirm) return;
//     }

//     setSelectedAttendance(prev => ({
//       ...prev,
//       [id]: !prev[id],
//     }));
//   };

//   const getTodayDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchTodayAttendance(date, department, selectedLocation));
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, selectedLocation, employeeId, department]);

//   useEffect(() => {
//     // Only run on initial load when data is available
//     if (initialLoad && attendanceItems && jobValue && attendanceItems.length > 0) {
//       const updatedSelectedAttendance = {};
//       attendanceItems.forEach(item => {
//         const isAssigned = selectedJobIwno ? isEmployeeAssignedToSelectedJob(item.iwNo) : false;
//         updatedSelectedAttendance[item.id] = isAssigned;
//       });
//       setSelectedAttendance(updatedSelectedAttendance);
//       setInitialLoad(false);
//     }
//   }, [attendanceItems, jobValue, selectedJobIwno, initialLoad]);

//   const handleSubmit = () => {
//     const selectedEmpIds = Object.keys(selectedAttendance).filter(
//       (key) => selectedAttendance[key]
//     );

//     // Filter out employees who are already assigned in unassigned view
//     const validSelectedEmpIds = selectedEmpIds.filter(id => {
//       if (viewMode === "unassigned") {
//         const item = attendanceItems.find(item => item.id === parseInt(id));
//         return item && !isEmployeeAssignedToAnyJob(item.iwNo);
//       }
//       return true;
//     });

//     if (validSelectedEmpIds.length === 0) {
//       setSnackbarMessage("Please select at least one unassigned employee.");
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }

//     const atttendJobList = validSelectedEmpIds.map((id) => {
//       let iwNoToSend = selectedJobIwno ? selectedJobIwno : "0"; 
      
//       return {
//         Id: id,
//         iwNo: iwNoToSend,
//         supervisorserviceno: employeeId,
//       };
//     });

//     const postData = {
//       atttendJobList: JSON.stringify(atttendJobList),
//       supervisor: employeeId,
//     };

//     dispatch(assignJob(postData));

//     // Clear selection after submit (only unassigned ones in unassigned view)
//     if (viewMode === "unassigned") {
//       const newSelectedAttendance = { ...selectedAttendance };
//       validSelectedEmpIds.forEach(id => {
//         delete newSelectedAttendance[id];
//       });
//       setSelectedAttendance(newSelectedAttendance);
//     } else {
//       // If a job is selected, keep checkmarks for employees assigned to that job
//       if (selectedJobIwno) {
//         const updated = {};
//         attendanceItems?.forEach(item => {
//           updated[item.id] = isEmployeeAssignedToSelectedJob(item.iwNo);
//         });
//         setSelectedAttendance(updated);
//       } else {
//         setSelectedAttendance({});
//       }
//     }
    
//     if (selectedJobIwno) {
//       setSnackbarMessage("Job assigned successfully!");
//     } else {
//       setSnackbarMessage("Job assignment removed successfully!");
//     }
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);
//   };

//   useEffect(() => {
//     if (jobAssignmentLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       } else {
//         const date = getTodayDate();
//         dispatch(fetchTodayAttendance(date, department, selectedLocation));
//         dispatch(fetchJobs(date, employeeId));
        
//         // Reset checkboxes based on current job selection
//         if (selectedJobIwno) {
//           const updated = {};
//           attendanceItems?.forEach(item => {
//             updated[item.id] = isEmployeeAssignedToSelectedJob(item.iwNo);
//           });
//           setSelectedAttendance(updated);
//         } else {
//           setSelectedAttendance({});
//         }
        
//         setInitialLoad(true);
//       }
//     }
//   }, [jobAssignmentLoading, error, dispatch, department, selectedLocation, employeeId]);

//   const filteredAttendanceItems = (attendanceItems || [])
//     .filter((item) =>
//       item?.serviceNo?.toLowerCase().includes(searchQuery.toLowerCase())
//     )
//     .filter(filterEmployeesByJob);

//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />
      
//       {/* Search Bar */}
//       <Box sx={{ marginBottom: 2 }}>
//         <TextField
//           fullWidth
//           label="Search by Service Number"
//           variant="outlined"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: "#154C79" }} />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             color: "#154C79",
//             borderRadius: "20px",
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "20px",
//             },
//             "& .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#154C79",
//             },
//           }}
//         />
//       </Box>

//       {/* Location and Job Dropdowns */}
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Location
//             </InputLabel>
//             <Select
//               value={selectedLocation}
//               onChange={handleLocationChange}
//               label="Location"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {locationLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 locationValue?.map((location, index) => (
//                   <MenuItem
//                     key={index}
//                     value={location.location}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {location.locationDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
        
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Job
//             </InputLabel>
//             <Select
//               value={selectedJob}
//               onChange={handleJobChange}
//               label="Job"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               <MenuItem value="">
//                 <em>No Job Selected</em>
//               </MenuItem>
//               {jobLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 jobValue?.map((job, index) => (
//                   <MenuItem
//                     key={index}
//                     value={job.jobDescription}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {job.jobDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       {/* View Mode Toggle */}
//       <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//         <FilterListIcon sx={{ color: '#154C79' }} />
//         <ToggleButtonGroup
//           value={viewMode}
//           exclusive
//           onChange={(e, newMode) => newMode && setViewMode(newMode)}
//           size="small"
//           sx={{
//             '& .MuiToggleButton-root': {
//               borderColor: '#154C79',
//               color: '#154C79',
//               '&.Mui-selected': {
//                 backgroundColor: '#154C79',
//                 color: 'white',
//               }
//             }
//           }}
//         >
//           <ToggleButton value="all">All Employees</ToggleButton>
//           {selectedJobIwno && (
//             <ToggleButton value="selected-job">Assigned to Selected Job</ToggleButton>
//           )}
//           <ToggleButton value="unassigned">Unassigned Only</ToggleButton>
//         </ToggleButtonGroup>
//       </Box>

//       {/* Attendance List */}
//       <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
//         {loading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               marginTop: "20px",
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : filteredAttendanceItems && filteredAttendanceItems.length > 0 ? (
//           filteredAttendanceItems.map((item) => {
//             const assignedJob = getEmployeeJob(item.iwNo);
//             const isAssignedToSelectedJob = isEmployeeAssignedToSelectedJob(item.iwNo);
//             const isAssignedToOtherJob = assignedJob && !isAssignedToSelectedJob;
//             const isAssignedToAnyJob = isEmployeeAssignedToAnyJob(item.iwNo);
            
//             // Determine checkbox state based on view mode
//             const shouldCheckboxBeChecked = !!selectedAttendance[item.id];

//             return (
//               <Box
//                 key={item.id}
//                 sx={{
//                   padding: "15px",
//                   borderRadius: "10px",
//                   marginBottom: "10px",
//                   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                   backgroundColor: isAssignedToSelectedJob ? "#e8f5e8" :
//                     isAssignedToOtherJob ? "#fff3e0" : "#fff",
//                   border: isAssignedToSelectedJob ? "2px solid #4CAF50" :
//                     isAssignedToOtherJob ? "2px solid #FFA500" : "1px solid #ddd",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                 }}
//               >
//                 <img
//                   src={`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
//                   alt={item.EmpName}
//                   style={{
//                     width: "50px",
//                     height: "50px",
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                     border: "2px solid #ddd",
//                     marginRight: "15px",
//                   }}
//                   onError={(e) => (e.target.src = "/placeholder-image.jpg")}
//                 />
                 
//                 <Box sx={{ flexGrow: 1, marginLeft: 1 }}>
//                   <Typography
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#121212",
//                       fontSize: "14px",
//                       marginRight: "10px",
//                     }}
//                   >
//                     {item.EmpName}
//                   </Typography>

//                   {isAssignedToSelectedJob && (
//                     <Typography
//                       sx={{
//                         color: "#4CAF50",
//                         fontSize: "12px",
//                         fontWeight: "normal",
//                       }}
//                     >
//                       (Assigned to this job)
//                     </Typography>
//                   )}
//                   {isAssignedToOtherJob && (
//                     <Typography
//                       sx={{
//                         color: "#FFA500",
//                         fontSize: "12px",
//                         fontWeight: "normal",
//                       }}
//                     >
//                       (Assigned to: {assignedJob?.jobDescription})
//                     </Typography>
//                   )}

//                   <Typography
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#121212",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.serviceNo}
//                   </Typography>
//                 </Box>

//                 <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
//                   <Typography
//                     sx={{
//                       color: "#239B56",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.inTime || "N/A"}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       color: "#E74C3C",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.outTime || "N/A"}
//                   </Typography>
//                 </Box>
                
//                 {/* Fixed Checkbox */}
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={shouldCheckboxBeChecked}
//                       disabled={
//                         viewMode === "unassigned" 
//                           ? isAssignedToAnyJob
//                           : isAssignedToOtherJob
//                       }
//                       onChange={() => handleCheckboxChange(item.id, item.iwNo)}
//                       color={isAssignedToOtherJob ? "warning" : "primary"}
//                     />
//                   }
//                   label=""
//                   disabled={
//                     viewMode === "unassigned" 
//                       ? isAssignedToAnyJob
//                       : isAssignedToOtherJob
//                   }
//                 />
//               </Box>
//             );
//           })
//         ) : (
//           <Typography
//             variant="body1"
//             sx={{ textAlign: "center", padding: "20px" }}
//           >
//             {viewMode === 'selected-job' && selectedJobIwno 
//               ? "No employees assigned to this job."
//               : viewMode === 'unassigned'
//               ? "All employees are assigned to jobs."
//               : "No attendance data available."}
//           </Typography>
//         )}
//       </Box>

//       {/* Submit Button */}
//       <Box
//         sx={{ display: "flex", justifyContent: "center", marginTop: "20px", gap: 2 }}
//       >
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           disabled={jobAssignmentLoading}
//           sx={{
//             backgroundColor: "#142C54",
//             color: "#fff",
//             fontSize: "1rem",
//             borderRadius: "10px",
//             padding: "10px 20px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//             "&:hover": {
//               backgroundColor: "#0E3C59",
//             },
//             "&:disabled": {
//               backgroundColor: "#cccccc",
//             }
//           }}
//         >
//           {jobAssignmentLoading ? (
//             <CircularProgress size={24} color="inherit" />
//           ) : selectedJobIwno ? (
//             "Assign Job"
//           ) : (
//             "Remove Job Assignment"
//           )}
//         </Button>
//       </Box>

//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AssignJob;




//--------------------------------------Working Code Above--------------------------------------

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   TextField,
//   InputAdornment,
//   Chip,
//   ToggleButton,
//   ToggleButtonGroup,
//   Tooltip,
//   IconButton,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import SelectAllIcon from "@mui/icons-material/SelectAll";
// import ClearAllIcon from "@mui/icons-material/ClearAll";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { fetchTodayAttendance } from "../actions/TodayAction";
// import { fetchJobs, fetchLocations, assignJob } from "../actions/AssignAction";

// const AssignJob = () => {
//   const dispatch = useDispatch();
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.todayAttendance || {}
//   );
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: jobAssignmentLoading, error } = useSelector(
//     (state) => state.assignJobpost || {}
//   );

//   const [selectedJob, setSelectedJob] = useState("");
//   const [selectedJobIwno, setSelectedJobIwno] = useState("");
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [viewMode, setViewMode] = useState("unassigned");

//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};
//   const [selectedLocation, setSelectedLocation] = useState(role);

//   const getEmployeeJob = (employeeIwNo) => {
//     if (!jobValue || !employeeIwNo || employeeIwNo === 0) return null;
//     return jobValue.find(job => job.iwNo === employeeIwNo.toString());
//   };

//   const isEmployeeAssignedToSelectedJob = (employeeIwNo) => {
//     if (!employeeIwNo || employeeIwNo === 0 || !selectedJobIwno) return false;
//     const assignedJob = getEmployeeJob(employeeIwNo);
//     return assignedJob && assignedJob.iwNo === selectedJobIwno;
//   };

//   const isEmployeeAssignedToAnyJob = (employeeIwNo) => {
//     if (!employeeIwNo || employeeIwNo === 0) return false;
//     return !!getEmployeeJob(employeeIwNo);
//   };

//   const selectAllEmployeesForJob = () => {
//     if (!attendanceItems || attendanceItems.length === 0) {
//       setSnackbarMessage("No employees available.");
//       setSnackbarSeverity("warning");
//       setSnackbarOpen(true);
//       return;
//     }

//     if (!selectedJobIwno) {
//       setSnackbarMessage("Please select a job first.");
//       setSnackbarSeverity("warning");
//       setSnackbarOpen(true);
//       return;
//     }

//     const updatedSelectedAttendance = { ...selectedAttendance };


//     let employeesToSelect = filteredAttendanceItems;

//     employeesToSelect.forEach(item => {
//       if (!isEmployeeAssignedToSelectedJob(item.iwNo)) {
//         updatedSelectedAttendance[item.id] = true;
//       }
//     });

//     setSelectedAttendance(updatedSelectedAttendance);

//     setSnackbarMessage(`Selected ${employeesToSelect.length} employee(s).`);
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);
//   };

//   const clearAllSelections = () => {
//     setSelectedAttendance({});
//     setSnackbarMessage("All selections cleared.");
//     setSnackbarSeverity("info");
//     setSnackbarOpen(true);
//   };

//   const filterEmployeesByJob = (employee) => {
//     switch (viewMode) {
//       case 'selected-job':
//         return selectedJobIwno && isEmployeeAssignedToSelectedJob(employee.iwNo);
//       case 'unassigned':
//         return !isEmployeeAssignedToAnyJob(employee.iwNo);
//       case 'all':
//       default:
//         return true;
//     }
//   };

//   const handleJobChange = (event) => {
//     const selectedJobValue = event.target.value;
//     if (selectedJobValue) {
//       const selectedJobData = jobValue.find(
//         (job) => job.jobDescription === selectedJobValue
//       );
//       if (selectedJobData) {
//         setSelectedJob(selectedJobValue);
//         setSelectedJobIwno(selectedJobData.iwNo);

//       }
//     } else {
//       setSelectedJob("");
//       setSelectedJobIwno("");
//     }
//   };

//   const handleLocationChange = (event) => {
//     setSelectedLocation(event.target.value);
//   };

//   const handleCheckboxChange = (id, employeeIwNo) => {
//     setSelectedAttendance((prev) => {
//       const updatedState = { ...prev, [id]: !prev[id] };
//       return updatedState;
//     });
//   };

//   const getTodayDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchTodayAttendance(date, department, selectedLocation));
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, selectedLocation, employeeId, department]);

//   const handleSubmit = () => {
//     const selectedEmpIds = Object.keys(selectedAttendance).filter(
//       (key) => selectedAttendance[key]
//     );

//     if (selectedEmpIds.length === 0) {
//       setSnackbarMessage("Please select at least one employee.");
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }

//     if (!selectedJobIwno) {

//       const atttendJobList = selectedEmpIds.map((id) => {
//         const employee = attendanceItems.find(item => item.id === parseInt(id));
//         const employeeIwNo = employee ? employee.iwNo : "0";

//         return {
//           Id: id,
//           iwNo: "0",
//           supervisorserviceno: employeeId,
//           employeeIwNo: employeeIwNo
//         };
//       });

//       const postData = {
//         atttendJobList: JSON.stringify(atttendJobList),
//         supervisor: employeeId,
//       };

//       dispatch(assignJob(postData));
//       setSnackbarMessage("Job removed from selected employees!");
//       setSnackbarSeverity("success");
//       setSnackbarOpen(true);

//       setSelectedAttendance({});
//       return;
//     }

//     const atttendJobList = selectedEmpIds.map((id) => {
//       return {
//         Id: id,
//         iwNo: selectedJobIwno,
//         supervisorserviceno: employeeId,
//       };
//     });

//     const postData = {
//       atttendJobList: JSON.stringify(atttendJobList),
//       supervisor: employeeId,
//     };

//     dispatch(assignJob(postData));

//     setSelectedAttendance({});

//     setSnackbarMessage("Job assigned successfully!");
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);
//   };

//   useEffect(() => {
//     if (jobAssignmentLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       } else {
//         const date = getTodayDate();
//         dispatch(fetchTodayAttendance(date, department, selectedLocation));
//         dispatch(fetchJobs(date, employeeId));
//         setSelectedAttendance({});
//       }
//     }
//   }, [jobAssignmentLoading, error, dispatch, department, selectedLocation, employeeId]);

//   const filteredAttendanceItems = (attendanceItems || [])
//     .filter((item) =>
//       item?.serviceNo?.toLowerCase().includes(searchQuery.toLowerCase())
//     )
//     .filter(filterEmployeesByJob);

//   const totalEmployees = attendanceItems?.length || 0;
//   const selectedCount = Object.values(selectedAttendance).filter(Boolean).length;
//   const assignedToSelectedJobCount = attendanceItems?.filter(item =>
//     isEmployeeAssignedToSelectedJob(item.iwNo)
//   ).length || 0;
//   const unassignedCount = attendanceItems?.filter(item =>
//     !isEmployeeAssignedToAnyJob(item.iwNo)
//   ).length || 0;

//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />

//       {/* Search Bar */}
//       <Box sx={{ marginBottom: 2 }}>
//         <TextField
//           fullWidth
//           label="Search by Service Number"
//           variant="outlined"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: "#154C79" }} />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             color: "#154C79",
//             borderRadius: "20px",
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "20px",
//             },
//             "& .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#154C79",
//             },
//           }}
//         />
//       </Box>

//       {/* Stats and Quick Actions Bar */}
//       <Box sx={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         mb: 2,
//         flexWrap: 'wrap',
//         gap: 1
//       }}>
//         {/* <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//           <Chip 
//             label={`Total Employees: ${totalEmployees}`} 
//             color="primary" 
//             variant="outlined" 
//           />
//           <Chip 
//             label={`Selected: ${selectedCount}`} 
//             color={selectedCount > 0 ? "primary" : "default"}
//             variant={selectedCount > 0 ? "filled" : "outlined"}
//           />
//           <Chip 
//             label={`Assigned to this Job: ${assignedToSelectedJobCount}`} 
//             color="success" 
//             variant="outlined" 
//           />
//           <Chip 
//             label={`Unassigned: ${unassignedCount}`} 
//             color="warning" 
//             variant="outlined" 
//           />
//         </Box> */}

//         {/* <Box sx={{ display: 'flex', gap: 1 }}>
//           <Tooltip title="Select All Employees">
//             <IconButton 
//               onClick={selectAllEmployeesForJob}
//               disabled={!selectedJobIwno}
//               sx={{ 
//                 color: selectedJobIwno ? '#154C79' : '#ccc',
//                 border: '1px solid',
//                 borderColor: selectedJobIwno ? '#154C79' : '#ccc'
//               }}
//             >
//               <SelectAllIcon />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Clear All Selections">
//             <IconButton 
//               onClick={clearAllSelections}
//               disabled={selectedCount === 0}
//               sx={{ 
//                 color: selectedCount > 0 ? '#154C79' : '#ccc',
//                 border: '1px solid',
//                 borderColor: selectedCount > 0 ? '#154C79' : '#ccc'
//               }}
//             >
//               <ClearAllIcon />
//             </IconButton>
//           </Tooltip>
//         </Box> */}
//       </Box>

//       {/* Location and Job Dropdowns */}
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Location
//             </InputLabel>
//             <Select
//               value={selectedLocation}
//               onChange={handleLocationChange}
//               label="Location"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {locationLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 locationValue?.map((location, index) => (
//                   <MenuItem
//                     key={index}
//                     value={location.location}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {location.locationDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Job
//             </InputLabel>
//             <Select
//               value={selectedJob}
//               onChange={handleJobChange}
//               label="Job"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               <MenuItem value="">
//                 <em>Select a Job / Remove Job</em>
//               </MenuItem>
//               {jobLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 jobValue?.map((job, index) => (
//                   <MenuItem
//                     key={index}
//                     value={job.jobDescription}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {job.jobDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       {/* View Mode Toggle */}
//       <Box sx={{
//         mb: 2,
//         display: 'flex',
//         alignItems: 'center',
//         gap: 1,
//         justifyContent: {
//           xs: 'center',
//           sm: 'flex-start'
//         },
//         flexWrap: 'wrap',

//       }}>

//         <ToggleButtonGroup
//           value={viewMode}
//           exclusive
//           onChange={(e, newMode) => newMode && setViewMode(newMode)}
//           size="small"
//           sx={{

//             '& .MuiToggleButton-root': {
//               borderColor: '#154C79',
//               color: '#154C79',
//               textTransform: 'none',

//               '&:hover': {
//                 backgroundColor: 'rgba(21, 76, 121, 0.08)',
//               },

//               '&.Mui-selected': {

//                 backgroundColor: '#154C79',
//                 color: '#fff',
//                 fontWeight: 500,

//                 '&:hover': {
//                   backgroundColor: '#154C79',
//                 }
//               },

//               '&.Mui-focusVisible': {
//                 backgroundColor: '#154C79',
//                 color: '#fff',
//               }
//             }
//           }}
//         >
//           <ToggleButton value="all">All Employees</ToggleButton>
//           {selectedJobIwno && (
//             <ToggleButton value="selected-job">Assigned Emp</ToggleButton>
//           )}
//           <ToggleButton value="unassigned">UnAssigned Emp</ToggleButton>
//         </ToggleButtonGroup>
//       </Box>

//       {/* Attendance List */}
//       <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
//         {loading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               marginTop: "20px",
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : filteredAttendanceItems && filteredAttendanceItems.length > 0 ? (
//           filteredAttendanceItems.map((item) => {
//             const assignedJob = getEmployeeJob(item.iwNo);
//             const isAssignedToSelectedJob = isEmployeeAssignedToSelectedJob(item.iwNo);
//             const isAssignedToOtherJob = assignedJob && !isAssignedToSelectedJob;
//             const isAssignedToAnyJob = isAssignedToSelectedJob || isAssignedToOtherJob;

//             return (
//               <Box
//                 key={item.id}
//                 sx={{
//                   padding: "15px",
//                   borderRadius: "10px",
//                   marginBottom: "10px",
//                   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                   backgroundColor: isAssignedToSelectedJob ? "#e8f5e8" :
//                     isAssignedToOtherJob ? "#fff3e0" : "#fff",
//                   border: isAssignedToSelectedJob ? "2px solid #4CAF50" :
//                     isAssignedToOtherJob ? "2px solid #FFA500" : "1px solid #ddd",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                 }}
//               >
//                 <img
//                   src={`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
//                   alt={item.EmpName}
//                   style={{
//                     width: "50px",
//                     height: "50px",
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                     border: "2px solid #ddd",
//                     marginRight: "15px",
//                   }}
//                   onError={(e) => (e.target.src = "/placeholder-image.jpg")}
//                 />

//                 <Box sx={{ flexGrow: 1, marginLeft: 1 }}>
//                   <Typography
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#121212",
//                       fontSize: "14px",
//                       marginRight: "10px",
//                     }}
//                   >
//                     {item.EmpName}
//                   </Typography>

//                   {isAssignedToSelectedJob && (
//                     <Typography
//                       sx={{
//                         color: "#4CAF50",
//                         fontSize: "12px",
//                         fontWeight: "normal",
//                       }}
//                     >
//                       (Assigned to this job)
//                     </Typography>
//                   )}
//                   {isAssignedToOtherJob && (
//                     <Typography
//                       sx={{
//                         color: "#FFA500",
//                         fontSize: "12px",
//                         fontWeight: "normal",
//                       }}
//                     >
//                       (Assigned to: {assignedJob?.jobDescription})
//                     </Typography>
//                   )}

//                   <Typography
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#121212",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.serviceNo}
//                   </Typography>
//                 </Box>

//                 <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
//                   <Typography
//                     sx={{
//                       color: "#239B56",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.inTime || "N/A"}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       color: "#E74C3C",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item.outTime || "N/A"}
//                   </Typography>
//                 </Box>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       sx={{ flexGrow: 0, marginLeft: 3 }}
//                       checked={!!selectedAttendance[item.id]}
//                       onChange={() => handleCheckboxChange(item.id, item.iwNo)}
//                       color={isAssignedToOtherJob ? "warning" : "primary"}
//                     />
//                   }
//                   label=""
//                 />
//               </Box>
//             );
//           })
//         ) : (
//           <Typography
//             variant="body1"
//             sx={{ textAlign: "center", padding: "20px" }}
//           >
//             {viewMode === 'selected-job' && selectedJobIwno
//               ? "No employees assigned to this job."
//               : viewMode === 'unassigned'
//                 ? "All employees are assigned to jobs."
//                 : "No attendance data available."}
//           </Typography>
//         )}
//       </Box>

//       {/* Submit Button */}
//       <Box
//         sx={{ display: "flex", justifyContent: "center", marginTop: "20px", gap: 2 }}
//       >
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           disabled={jobAssignmentLoading || selectedCount === 0}
//           sx={{
//             backgroundColor: "#142C54",
//             color: "#fff",
//             fontSize: "1rem",
//             borderRadius: "10px",
//             padding: "10px 20px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//             "&:hover": {
//               backgroundColor: "#0E3C59",
//             },
//             "&:disabled": {
//               backgroundColor: "#cccccc",
//             }
//           }}
//         >
//           {jobAssignmentLoading ? (
//             <CircularProgress size={24} color="inherit" />
//           ) : selectedJobIwno ? (
//             "Assign Job"
//           ) : (
//             "Remove Job"
//           )}
//         </Button>
//       </Box>

//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AssignJob;


//----------------------------------------------------------------------------------------------------------------------------------
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   TextField,
//   InputAdornment,
//   Chip,
//   ToggleButton,
//   ToggleButtonGroup,
//   Tooltip,
//   IconButton,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import SelectAllIcon from "@mui/icons-material/SelectAll";
// import ClearAllIcon from "@mui/icons-material/ClearAll";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { fetchTodayAttendance } from "../actions/TodayAction";
// import { fetchJobs, fetchLocations, assignJob } from "../actions/AssignAction";

// const AssignJob = () => {
//   const dispatch = useDispatch();
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.todayAttendance || {}
//   );
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: jobAssignmentLoading, error } = useSelector(
//     (state) => state.assignJobpost || {}
//   );

//   const [selectedJob, setSelectedJob] = useState("");
//   const [selectedJobIwno, setSelectedJobIwno] = useState("");
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [viewMode, setViewMode] = useState("unassigned");

//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};
//   const [selectedLocation, setSelectedLocation] = useState(role);

//   const getEmployeeJob = (employeeIwNo) => {
//     if (!jobValue || !employeeIwNo || employeeIwNo === 0) return null;
//     return jobValue.find(job => job.iwNo === employeeIwNo.toString());
//   };

//   const isEmployeeAssignedToSelectedJob = (employeeIwNo) => {
//     if (!employeeIwNo || employeeIwNo === 0 || !selectedJobIwno) return false;
//     const assignedJob = getEmployeeJob(employeeIwNo);
//     return assignedJob && assignedJob.iwNo === selectedJobIwno;
//   };

//   const isEmployeeAssignedToAnyJob = (employeeIwNo) => {
//     if (!employeeIwNo || employeeIwNo === 0) return false;
//     return !!getEmployeeJob(employeeIwNo);
//   };
  
//  const isAssignedByOtherSupervisor = (employee) => {
//   return (
//     employee?.iwNo !== null &&                 // job assigned
//     employee?.SupervisorServiceNo &&           // has supervisor
//     employee.SupervisorServiceNo !== employeeId // not logged supervisor
//   );
// };
//   const selectAllEmployeesForJob = () => {
//     if (!attendanceItems || attendanceItems.length === 0) {
//       setSnackbarMessage("No employees available.");
//       setSnackbarSeverity("warning");
//       setSnackbarOpen(true);
//       return;
//     }

//     if (!selectedJobIwno) {
//       setSnackbarMessage("Please select a job first.");
//       setSnackbarSeverity("warning");
//       setSnackbarOpen(true);
//       return;
//     }

//     const updatedSelectedAttendance = { ...selectedAttendance };


//     let employeesToSelect = filteredAttendanceItems;

//     employeesToSelect.forEach(item => {
//       if (!isEmployeeAssignedToSelectedJob(item.iwNo)) {
//         updatedSelectedAttendance[item.id] = true;
//       }
//     });

//     setSelectedAttendance(updatedSelectedAttendance);

//     setSnackbarMessage(`Selected ${employeesToSelect.length} employee(s).`);
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);
//   };

//   const clearAllSelections = () => {
//     setSelectedAttendance({});
//     setSnackbarMessage("All selections cleared.");
//     setSnackbarSeverity("info");
//     setSnackbarOpen(true);
//   };

//   //------------Dulitha-----------
// const filterEmployeesByJob = (employee) => {
//   switch (viewMode) {
//     case "selected-job":
//       return selectedJobIwno && isEmployeeAssignedToSelectedJob(employee.iwNo);

//     case "unassigned":
//       return (
//         employee.iwNo > 0 &&
//         employee.SupervisorServiceNo &&
//         employee.SupervisorServiceNo !== employeeId
//       );

//     case "notassigned":
//       return employee.iwNo === 0;

//     case "all":
//     default:
//       return true;
//   }
// };



//   const handleJobChange = (event) => {
//     const selectedJobValue = event.target.value;
//     if (selectedJobValue) {
//       const selectedJobData = jobValue.find(
//         (job) => job.jobDescription === selectedJobValue
//       );
//       if (selectedJobData) {
//         setSelectedJob(selectedJobValue);
//         setSelectedJobIwno(selectedJobData.iwNo);

//       }
//     } else {
//       setSelectedJob("");
//       setSelectedJobIwno("");
//     }
//   };

//   const handleLocationChange = (event) => {
//     setSelectedLocation(event.target.value);
//   };

//   const handleCheckboxChange = (id, employeeIwNo) => {
//     setSelectedAttendance((prev) => {
//       const updatedState = { ...prev, [id]: !prev[id] };
//       return updatedState;
//     });
//   };

//   const getTodayDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchTodayAttendance(date, department, selectedLocation));
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, selectedLocation, employeeId, department]);

//   const handleSubmit = () => {
//     const selectedEmpIds = Object.keys(selectedAttendance).filter(
//       (key) => selectedAttendance[key]
//     );

//     if (selectedEmpIds.length === 0) {
//       setSnackbarMessage("Please select at least one employee.");
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       return;
//     }

//     if (!selectedJobIwno) {

//       const atttendJobList = selectedEmpIds.map((id) => {
//         const employee = attendanceItems.find(item => item.id === parseInt(id));
//         const employeeIwNo = employee ? employee.iwNo : "0";
//         return {
//           Id: id,
//           iwNo: "0",
//           supervisorserviceno: employeeId,
//           employeeIwNo: employeeIwNo
//         };
//       });

//       const postData = {
//         atttendJobList: JSON.stringify(atttendJobList),
//         supervisor: employeeId,
//       };

//       dispatch(assignJob(postData));
//       setSnackbarMessage("Job removed from selected employees!");
//       setSnackbarSeverity("success");
//       setSnackbarOpen(true);

//       setSelectedAttendance({});
//       return;
//     }

//     const atttendJobList = selectedEmpIds.map((id) => {
//       return {
//         Id: id,
//         iwNo: selectedJobIwno,
//         supervisorserviceno: employeeId,
//       };
//     });

//     const postData = {
//       atttendJobList: JSON.stringify(atttendJobList),
//       supervisor: employeeId,
//     };

//     dispatch(assignJob(postData));

//     setSelectedAttendance({});

//     setSnackbarMessage("Job assigned successfully!");
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);
//   };

//   useEffect(() => {
//     if (jobAssignmentLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       } else {
//         const date = getTodayDate();
//         dispatch(fetchTodayAttendance(date, department, selectedLocation));
//         dispatch(fetchJobs(date, employeeId));
//         setSelectedAttendance({});
//       }
//     }
//   }, [jobAssignmentLoading, error, dispatch, department, selectedLocation, employeeId]);

//   const filteredAttendanceItems = (attendanceItems || [])
//     .filter((item) =>
//       item?.serviceNo?.toLowerCase().includes(searchQuery.toLowerCase())
//     )
//     .filter(filterEmployeesByJob);

//   const totalEmployees = attendanceItems?.length || 0;
//   const selectedCount = Object.values(selectedAttendance).filter(Boolean).length;
//   const assignedToSelectedJobCount = attendanceItems?.filter(item =>
//     isEmployeeAssignedToSelectedJob(item.iwNo)
//   ).length || 0;
//   const unassignedCount = attendanceItems?.filter(item =>
//     !isEmployeeAssignedToAnyJob(item.iwNo)
//   ).length || 0;


//   //----------Dulitha---------
//   const isIwNoNull = (employeeIwNo) => {
//   return employeeIwNo === null;
// };


//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />

//       {/* Search Bar */}
//       <Box sx={{ marginBottom: 2 }}>
//         <TextField
//           fullWidth
//           label="Search by Service Number"
//           variant="outlined"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: "#154C79" }} />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             color: "#154C79",
//             borderRadius: "20px",
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "20px",
//             },
//             "& .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#154C79",
//             },
//           }}
//         />
//       </Box>

//       {/* Stats and Quick Actions Bar */}
//       <Box sx={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         mb: 2,
//         flexWrap: 'wrap',
//         gap: 1
//       }}>
//         {/* <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//           <Chip 
//             label={`Total Employees: ${totalEmployees}`} 
//             color="primary" 
//             variant="outlined" 
//           />
//           <Chip 
//             label={`Selected: ${selectedCount}`} 
//             color={selectedCount > 0 ? "primary" : "default"}
//             variant={selectedCount > 0 ? "filled" : "outlined"}
//           />
//           <Chip 
//             label={`Assigned to this Job: ${assignedToSelectedJobCount}`} 
//             color="success" 
//             variant="outlined" 
//           />
//           <Chip 
//             label={`Unassigned: ${unassignedCount}`} 
//             color="warning" 
//             variant="outlined" 
//           />
//         </Box> */}

//         {/* <Box sx={{ display: 'flex', gap: 1 }}>
//           <Tooltip title="Select All Employees">
//             <IconButton 
//               onClick={selectAllEmployeesForJob}
//               disabled={!selectedJobIwno}
//               sx={{ 
//                 color: selectedJobIwno ? '#154C79' : '#ccc',
//                 border: '1px solid',
//                 borderColor: selectedJobIwno ? '#154C79' : '#ccc'
//               }}
//             >
//               <SelectAllIcon />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Clear All Selections">
//             <IconButton 
//               onClick={clearAllSelections}
//               disabled={selectedCount === 0}
//               sx={{ 
//                 color: selectedCount > 0 ? '#154C79' : '#ccc',
//                 border: '1px solid',
//                 borderColor: selectedCount > 0 ? '#154C79' : '#ccc'
//               }}
//             >
//               <ClearAllIcon />
//             </IconButton>
//           </Tooltip>
//         </Box> */}
//       </Box>

//       {/* Location and Job Dropdowns */}
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Location
//             </InputLabel>
//             <Select
//               value={selectedLocation}
//               onChange={handleLocationChange}
//               label="Location"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {locationLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 locationValue?.map((location, index) => (
//                   <MenuItem
//                     key={index}
//                     value={location.location}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {location.locationDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Job
//             </InputLabel>
//             <Select
//               value={selectedJob}
//               onChange={handleJobChange}
//               label="Job"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               <MenuItem value="">
//                 <em>Select a Job / Remove Job</em>
//               </MenuItem>
//               {jobLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 jobValue?.map((job, index) => (
//                   <MenuItem
//                     key={index}
//                     value={job.jobDescription}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {job.jobDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       {/* View Mode Toggle */}
//       <Box sx={{
//         mb: 2,
//         display: 'flex',
//         alignItems: 'center',
//         gap: 1,
//         justifyContent: {
//           xs: 'center',
//           sm: 'flex-start'
//         },
//         flexWrap: 'wrap',

//       }}>

//         <ToggleButtonGroup
//           value={viewMode}
//           exclusive
//           onChange={(e, newMode) => newMode && setViewMode(newMode)}
//           size="small"
//           sx={{

//             '& .MuiToggleButton-root': {
//               borderColor: '#154C79',
//               color: '#154C79',
//               textTransform: 'none',

//               '&:hover': {
//                 backgroundColor: 'rgba(21, 76, 121, 0.08)',
//               },

//               '&.Mui-selected': {

//                 backgroundColor: '#154C79',
//                 color: '#fff',
//                 fontWeight: 500,

//                 '&:hover': {
//                   backgroundColor: '#154C79',
//                 }
//               },

//               '&.Mui-focusVisible': {
//                 backgroundColor: '#154C79',
//                 color: '#fff',
//               }
//             }
//           }}
//         >
//           <ToggleButton value="all">All Employees</ToggleButton>
//           {selectedJobIwno && (
//             <ToggleButton value="selected-job">Assigned Emp</ToggleButton>
//           )}
//           <ToggleButton value="unassigned">Other Assigned</ToggleButton>
//           <ToggleButton value="notassigned">Not Assigned</ToggleButton> 
//         </ToggleButtonGroup>
//       </Box>

//       {/* Attendance List */}
//       <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
//         {loading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               marginTop: "20px",
//             }}
//           >
//       <CircularProgress />
//     </Box>
//   ) : filteredAttendanceItems && filteredAttendanceItems.length > 0 ? (
//     filteredAttendanceItems.map((item) => {
//       const assignedJob = getEmployeeJob(item.iwNo);
//       const isAssignedToSelectedJob = isEmployeeAssignedToSelectedJob(item.iwNo);
//       const isAssignedToOtherJob = assignedJob && !isAssignedToSelectedJob;
//       const isAssignedToAnyJob = isAssignedToSelectedJob || isAssignedToOtherJob;
      
//       // other supervisor
//       const isAssignedByOther = isAssignedByOtherSupervisor(item);

//       return (
//           <Box
//             key={item.id}
//             sx={{
//               padding: "15px",
//               borderRadius: "10px",
//               marginBottom: "10px",
//               boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//               backgroundColor: 
//                 viewMode === "unassigned" ? "#c7c6c6" :
//                 isAssignedToSelectedJob ? "#e8f5e8" :
//                 isAssignedToOtherJob ? "#fff3e0" : "#fff",
//               border: 
//                 viewMode === "unassigned" ? "1px solid #bdbdbd" :
//                 isAssignedToSelectedJob ? "2px solid #4CAF50" :
//                 isAssignedToOtherJob ? "2px solid #FFA500" : "1px solid #ddd",
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//           <img
//             src={`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
//             alt={item.EmpName}
//             style={{
//               width: "50px",
//               height: "50px",
//               borderRadius: "50%",
//               objectFit: "cover",
//               border: "2px solid #ddd",
//               marginRight: "15px",
//             }}
//             onError={(e) => (e.target.src = "/placeholder-image.jpg")}
//           />

//           <Box sx={{ flexGrow: 1, marginLeft: 1 }}>
//             <Typography
//               sx={{
//                 fontWeight: "bold",
//                 color: "#121212",
//                 fontSize: "14px",
//                 marginRight: "10px",
//               }}
//             >
//               {item.EmpName}
//             </Typography>

//             {isAssignedToSelectedJob && (
//               <Typography
//                 sx={{
//                   color: "#4CAF50",
//                   fontSize: "12px",
//                   fontWeight: "normal",
//                 }}
//               >
//                 (Assigned to this job)
//               </Typography>
//             )}
            
//             {isAssignedToOtherJob && (
//               <Typography
//                 sx={{
//                   color: "#FFA500",
//                   fontSize: "12px",
//                   fontWeight: "normal",
//                 }}
//               >
//                 (Assigned to: {assignedJob?.jobDescription})
//               </Typography>
//             )}
            
//             {/* Show supervisor info when in "Other Assigned" view OR when in "All Employees" view and assigned by current user */}
//             {/* {((viewMode === "unassigned" && isAssignedByOther) || 
//               (viewMode === "all" && item.SupervisorServiceNo === employeeId && item.iwNo > 0)) && (
//               <Box sx={{ mt: 0.5 }}>
//                 <Typography
//                   sx={{
//                     color: "#926819",
//                     fontSize: "11px",
//                     fontWeight: "normal",
//                   }}
//                 >
//                   Supervisor: {item.SupervisorName || "N/A"}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     color: "#926819",
//                     fontSize: "11px",
//                     fontWeight: "normal",
//                   }}
//                 >
//                   Job: {item.jobDescription || "N/A"}
//                 </Typography>
//               </Box>
//             )} */}
            
//             {/* -------Dulitha---------- */}
//             {item.iwNo > 0 && (
//               <>
//                 {/* Other supervisor assigned */}
//                 {viewMode === "unassigned" && isAssignedByOther && (
//                   <Box sx={{ mt: 0.5 }}>
//                     <Typography sx={{ color: "#926819", fontSize: "11px" }}>
//                       Supervisor: {item.SupervisorName || "N/A"}
//                     </Typography>
//                     <Typography sx={{ color: "#926819", fontSize: "11px" }}>
//                       Job: {item.jobDescription || "Unassigned"}
//                     </Typography>
//                   </Box>
//                 )}

//                 {/* All employees view */}
//                 {viewMode === "all" && (
//                   <Box sx={{ mt: 0.5 }}>
//                     <Typography sx={{ color: "#926819", fontSize: "11px" }}>
//                       Supervisor: {item.SupervisorName || "N/A"}
//                     </Typography>
//                     <Typography sx={{ color: "#926819", fontSize: "11px" }}>
//                       Job: {item.jobDescription || "Unassigned"}
//                     </Typography>
//                   </Box>
//                 )}
//               </>
//             )}


//             <Typography
//               sx={{
//                 fontWeight: "bold",
//                 color: "#121212",
//                 fontSize: "14px",
//               }}
//             >
//               {item.serviceNo}
//             </Typography>
//           </Box>

//           <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
//             <Typography
//               sx={{
//                 color: "#239B56",
//                 fontWeight: "bold",
//                 fontSize: "14px",
//               }}
//             >
//               {item.inTime || "Available"}
//             </Typography>
//             <Typography
//               sx={{
//                 color: "#E74C3C",
//                 fontWeight: "bold",
//                 fontSize: "14px",
//               }}
//             >
//               {item.outTime || "Available"}
//             </Typography>
//           </Box>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 sx={{ flexGrow: 0, marginLeft: 3 }}
//                 checked={!!selectedAttendance[item.id]}
//                 onChange={() => handleCheckboxChange(item.id, item.iwNo)}
//                 color={isAssignedToOtherJob ? "warning" : "primary"}
//                 disabled={viewMode === "unassigned" && isAssignedByOther}
//               />
//             }
//             label=""
//           />
//         </Box>
//       );
//     })
//   ) : (
//     <Typography
//       variant="body1"
//       sx={{ textAlign: "center", padding: "20px" }}
//     >
//       {
//         viewMode === 'selected-job' && selectedJobIwno
//           ? "No employees assigned to this job."
//           : viewMode === 'unassigned'
//             ? "No employees assigned by other supervisors."
//             : viewMode === 'notassigned'
//               ? "All employees are assigned to jobs."
//               : "No attendance data available."
//       }
//     </Typography>
//   )}
// </Box>
//       {/* Submit Button */}
//       <Box
//         sx={{ display: "flex", justifyContent: "center", marginTop: "20px", gap: 2 }}
//       >
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           disabled={jobAssignmentLoading || selectedCount === 0}
//           sx={{
//             backgroundColor: "#142C54",
//             color: "#fff",
//             fontSize: "1rem",
//             borderRadius: "10px",
//             padding: "10px 20px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//             "&:hover": {
//               backgroundColor: "#0E3C59",
//             },
//             "&:disabled": {
//               backgroundColor: "#cccccc",
//             }
//           }}
//         >
//           {jobAssignmentLoading ? (
//             <CircularProgress size={24} color="inherit" />
//           ) : selectedJobIwno ? (
//             "Assign Job"
//           ) : (
//             "Remove Job"
//           )}
//         </Button>
//       </Box>

//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AssignJob;

//-----------------------------------Test------
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import {
//   Box,
//   CircularProgress,
//   Typography,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Snackbar,
//   Alert,
//   TextField,
//   InputAdornment,
//   Chip,
//   ToggleButton,
//   ToggleButtonGroup,
//   Tooltip,
//   IconButton,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import SelectAllIcon from "@mui/icons-material/SelectAll";
// import ClearAllIcon from "@mui/icons-material/ClearAll";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { fetchTodayAttendance } from "../actions/TodayAction";
// import { fetchJobs, fetchLocations, assignJob } from "../actions/AssignAction";

// const AssignJob = () => {
//   const dispatch = useDispatch();
//   const { attendanceItems, loading } = useSelector(
//     (state) => state.todayAttendance || {}
//   );
//   const { jobValue, loading: jobLoading } = useSelector(
//     (state) => state.assignJob || {}
//   );
//   const { locationValue, loading: locationLoading } = useSelector(
//     (state) => state.assignLocation || {}
//   );
//   const { loading: jobAssignmentLoading, error } = useSelector(
//     (state) => state.assignJobpost || {}
//   );

//   const [selectedJob, setSelectedJob] = useState("");
//   const [selectedJobIwno, setSelectedJobIwno] = useState("");
//   const [selectedAttendance, setSelectedAttendance] = useState({});
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [viewMode, setViewMode] = useState("unassigned");

//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};
//   const [selectedLocation, setSelectedLocation] = useState(role);

//   const getEmployeeJob = (employeeIwNo) => {
//     if (!jobValue || !employeeIwNo || employeeIwNo === 0) return null;
//     return jobValue.find(job => job.iwNo === employeeIwNo.toString());
//   };

//   const isEmployeeAssignedToSelectedJob = (employeeIwNo) => {
//     if (!employeeIwNo || employeeIwNo === 0 || !selectedJobIwno) return false;
//     const assignedJob = getEmployeeJob(employeeIwNo);
//     return assignedJob && assignedJob.iwNo === selectedJobIwno;
//   };

//   const isEmployeeAssignedToAnyJob = (employeeIwNo) => {
//     if (!employeeIwNo || employeeIwNo === 0) return false;
//     return !!getEmployeeJob(employeeIwNo);
//   };
  
//  const isAssignedByOtherSupervisor = (employee) => {
//   return (
//     employee?.iwNo !== null &&                 // job assigned
//     employee?.SupervisorServiceNo &&           // has supervisor
//     employee.SupervisorServiceNo !== employeeId // not logged supervisor
//   );
// };
//   const selectAllEmployeesForJob = () => {
//     if (!attendanceItems || attendanceItems.length === 0) {
//       setSnackbarMessage("No employees available.");
//       setSnackbarSeverity("warning");
//       setSnackbarOpen(true);
//       return;
//     }

//     if (!selectedJobIwno) {
//       setSnackbarMessage("Please select a job first.");
//       setSnackbarSeverity("warning");
//       setSnackbarOpen(true);
//       return;
//     }

//     const updatedSelectedAttendance = { ...selectedAttendance };


//     let employeesToSelect = filteredAttendanceItems;

//     employeesToSelect.forEach(item => {
//       if (!isEmployeeAssignedToSelectedJob(item.iwNo)) {
//         updatedSelectedAttendance[item.id] = true;
//       }
//     });

//     setSelectedAttendance(updatedSelectedAttendance);

//     setSnackbarMessage(`Selected ${employeesToSelect.length} employee(s).`);
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);
//   };

//   const clearAllSelections = () => {
//     setSelectedAttendance({});
//     setSnackbarMessage("All selections cleared.");
//     setSnackbarSeverity("info");
//     setSnackbarOpen(true);
//   };

//   //------------Dulitha-----------
// const filterEmployeesByJob = (employee) => {
//   switch (viewMode) {
//     case "selected-job":
//       return selectedJobIwno && isEmployeeAssignedToSelectedJob(employee.iwNo);

//     case "unassigned":
//       return (
//         employee.iwNo > 0 &&
//         employee.SupervisorServiceNo &&
//         employee.SupervisorServiceNo !== employeeId
//       );

//     case "notassigned":
//       return employee.iwNo === 0;

//     case "all":
//     default:
//       return true;
//   }
// };



//   const handleJobChange = (event) => {
//     const selectedJobValue = event.target.value;
//     if (selectedJobValue) {
//       const selectedJobData = jobValue.find(
//         (job) => job.jobDescription === selectedJobValue
//       );
//       if (selectedJobData) {
//         setSelectedJob(selectedJobValue);
//         setSelectedJobIwno(selectedJobData.iwNo);

//       }
//     } else {
//       setSelectedJob("");
//       setSelectedJobIwno("");
//     }
//   };

//   const handleLocationChange = (event) => {
//     setSelectedLocation(event.target.value);
//   };

//   const handleCheckboxChange = (id, employeeIwNo) => {
//     setSelectedAttendance((prev) => {
//       const updatedState = { ...prev, [id]: !prev[id] };
//       return updatedState;
//     });
//   };

//   const getTodayDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     if (employeeId && department) {
//       const date = getTodayDate();
//       dispatch(fetchTodayAttendance(date, department, selectedLocation));
//       dispatch(fetchJobs(date, employeeId));
//       dispatch(fetchLocations(department));
//     }
//   }, [dispatch, selectedLocation, employeeId, department]);

//   // const handleSubmit = () => {
//   //   const selectedEmpIds = Object.keys(selectedAttendance).filter(
//   //     (key) => selectedAttendance[key]
      
//   //   );

//   //   if (selectedEmpIds.length === 0) {
//   //     setSnackbarMessage("Please select at least one employee.");
//   //     setSnackbarSeverity("error");
//   //     setSnackbarOpen(true);
//   //     return;
//   //   }

//   //   if (!selectedJobIwno) {

//   //     const atttendJobList = selectedEmpIds.map((id) => {
//   //       const employee = attendanceItems.find(item => item.id === parseInt(id));
//   //       const employeeIwNo = employee ? employee.iwNo : "0";
//   //       return {
//   //         Id: id,
//   //         iwNo: "0",
//   //         supervisorserviceno: employeeId,
//   //         employeeIwNo: employeeIwNo
//   //       };
//   //     });

//   //     const postData = {
//   //       atttendJobList: JSON.stringify(atttendJobList),
//   //       supervisor: employeeId,
//   //     };
//   //     console.log("REMOVE JOB - Selected Emp IDs:", selectedEmpIds);
//   //     console.log("REMOVE JOB - Attend Job List:", atttendJobList);
//   //     console.log("REMOVE JOB - Final Post Data:", postData);

//   //     dispatch(assignJob(postData));
//   //     setSnackbarMessage("Job removed from selected employees!");
//   //     setSnackbarSeverity("success");
//   //     setSnackbarOpen(true);

//   //     setSelectedAttendance({});
//   //     return;
//   //   }

//   //   const atttendJobList = selectedEmpIds.map((id) => {
//   //     return {
//   //       Id: id,
//   //       iwNo: selectedJobIwno,
//   //       supervisorserviceno: employeeId,
//   //     };
//   //   });

//   //   const postData = {
//   //     atttendJobList: JSON.stringify(atttendJobList),
//   //     supervisor: employeeId,
//   //   };

//   //   dispatch(assignJob(postData));

//   //   setSelectedAttendance({});

//   //   setSnackbarMessage("Job assigned successfully!");
//   //   setSnackbarSeverity("success");
//   //   setSnackbarOpen(true);
//   // };

//   const handleSubmit = () => {
//   const selectedEmpIds = Object.keys(selectedAttendance).filter(
//     (key) => selectedAttendance[key]
//   );

//   if (selectedEmpIds.length === 0) {
//     setSnackbarMessage("Please select at least one employee.");
//     setSnackbarSeverity("error");
//     setSnackbarOpen(true);
//     return;
//   }

//   if (!selectedJobIwno) {
//     // Remove job scenario
//     const atttendJobList = selectedEmpIds.map((id) => {
//       const employee = attendanceItems.find(item => item.id === parseInt(id));
//       const employeeIwNo = employee ? employee.iwNo : "0";
//       return {
//         Id: id,
//         iwNo: "0", // removing job
//         supervisorserviceno: employeeId,
//         employeeIwNo: employeeIwNo
//       };
//     });

//     const postData = {
//       atttendJobList: JSON.stringify(atttendJobList),
//       supervisor: employeeId,
//     };

//     // ---------- Console logs ----------
//     console.log("REMOVE JOB - Selected Employee IDs:", selectedEmpIds);
//     console.log("REMOVE JOB - Attend Job List:", atttendJobList);
//     console.log("REMOVE JOB - Final Post Data to API:", postData);
//     // -----------------------------------

//     dispatch(assignJob(postData));

//     setSnackbarMessage("Job removed from selected employees!");
//     setSnackbarSeverity("success");
//     setSnackbarOpen(true);

//     setSelectedAttendance({});
//     return;
//   }

//   // Assign job scenario
//   const atttendJobList = selectedEmpIds.map((id) => {
//     const employee = attendanceItems.find(item => item.id === parseInt(id));
//     return {
//       Id: id,
//       iwNo: selectedJobIwno,
//       supervisorserviceno: employeeId,
//       employeeName: employee?.EmpName || "N/A",
//       serviceNo: employee?.serviceNo || "N/A"
//     };
//   });

//   const postData = {
//     atttendJobList: JSON.stringify(atttendJobList),
//     supervisor: employeeId,
//   };

//   // ---------- Console logs ----------
//   console.log("ASSIGN JOB - Selected Employee IDs:", selectedEmpIds);
//   console.log("ASSIGN JOB - Attend Job List:", atttendJobList);
//   console.log("ASSIGN JOB - Final Post Data to API:", postData);
//   // -----------------------------------

//   dispatch(assignJob(postData));

//   setSelectedAttendance({});
//   setSnackbarMessage("Job assigned successfully!");
//   setSnackbarSeverity("success");
//   setSnackbarOpen(true);
// };


//   useEffect(() => {
//     if (jobAssignmentLoading === false) {
//       if (error) {
//         setSnackbarMessage(`Error: ${error.message}`);
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       } else {
//         const date = getTodayDate();
//         dispatch(fetchTodayAttendance(date, department, selectedLocation));
//         dispatch(fetchJobs(date, employeeId));
//         setSelectedAttendance({});
//       }
//     }
//   }, [jobAssignmentLoading, error, dispatch, department, selectedLocation, employeeId]);

//   const filteredAttendanceItems = (attendanceItems || [])
//     .filter((item) =>
//       item?.serviceNo?.toLowerCase().includes(searchQuery.toLowerCase())
//     )
//     .filter(filterEmployeesByJob);

//   const totalEmployees = attendanceItems?.length || 0;
//   const selectedCount = Object.values(selectedAttendance).filter(Boolean).length;
//   const assignedToSelectedJobCount = attendanceItems?.filter(item =>
//     isEmployeeAssignedToSelectedJob(item.iwNo)
//   ).length || 0;
//   const unassignedCount = attendanceItems?.filter(item =>
//     !isEmployeeAssignedToAnyJob(item.iwNo)
//   ).length || 0;


//   //----------Dulitha---------
//   const isIwNoNull = (employeeIwNo) => {
//   return employeeIwNo === null;
// };


//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />

//       {/* Search Bar */}
//       <Box sx={{ marginBottom: 2 }}>
//         <TextField
//           fullWidth
//           label="Search by Service Number"
//           variant="outlined"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: "#154C79" }} />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             color: "#154C79",
//             borderRadius: "20px",
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "20px",
//             },
//             "& .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#154C79",
//             },
//           }}
//         />
//       </Box>

//       {/* Stats and Quick Actions Bar */}
//       <Box sx={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         mb: 2,
//         flexWrap: 'wrap',
//         gap: 1
//       }}>
//         {/* <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//           <Chip 
//             label={`Total Employees: ${totalEmployees}`} 
//             color="primary" 
//             variant="outlined" 
//           />
//           <Chip 
//             label={`Selected: ${selectedCount}`} 
//             color={selectedCount > 0 ? "primary" : "default"}
//             variant={selectedCount > 0 ? "filled" : "outlined"}
//           />
//           <Chip 
//             label={`Assigned to this Job: ${assignedToSelectedJobCount}`} 
//             color="success" 
//             variant="outlined" 
//           />
//           <Chip 
//             label={`Unassigned: ${unassignedCount}`} 
//             color="warning" 
//             variant="outlined" 
//           />
//         </Box> */}

//         {/* <Box sx={{ display: 'flex', gap: 1 }}>
//           <Tooltip title="Select All Employees">
//             <IconButton 
//               onClick={selectAllEmployeesForJob}
//               disabled={!selectedJobIwno}
//               sx={{ 
//                 color: selectedJobIwno ? '#154C79' : '#ccc',
//                 border: '1px solid',
//                 borderColor: selectedJobIwno ? '#154C79' : '#ccc'
//               }}
//             >
//               <SelectAllIcon />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Clear All Selections">
//             <IconButton 
//               onClick={clearAllSelections}
//               disabled={selectedCount === 0}
//               sx={{ 
//                 color: selectedCount > 0 ? '#154C79' : '#ccc',
//                 border: '1px solid',
//                 borderColor: selectedCount > 0 ? '#154C79' : '#ccc'
//               }}
//             >
//               <ClearAllIcon />
//             </IconButton>
//           </Tooltip>
//         </Box> */}
//       </Box>

//       {/* Location and Job Dropdowns */}
//       <Grid container spacing={2} sx={{ marginBottom: 3 }}>
//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Location
//             </InputLabel>
//             <Select
//               value={selectedLocation}
//               onChange={handleLocationChange}
//               label="Location"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {locationLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 locationValue?.map((location, index) => (
//                   <MenuItem
//                     key={index}
//                     value={location.location}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {location.locationDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={6}>
//           <FormControl fullWidth>
//             <InputLabel
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 color: "#154C79",
//               }}
//             >
//               Job
//             </InputLabel>
//             <Select
//               value={selectedJob}
//               onChange={handleJobChange}
//               label="Job"
//               sx={{
//                 fontSize: { xs: "0.85rem", sm: "1rem" },
//                 borderRadius: "20px",
//                 backgroundColor: "#F0F4F8",
//                 boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                 "& .MuiSelect-icon": {
//                   color: "#154C79",
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "#154C79",
//                 },
//               }}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               <MenuItem value="">
//                 <em>Select a Job / Remove Job</em>
//               </MenuItem>
//               {jobLoading ? (
//                 <MenuItem value="">
//                   <em>Loading...</em>
//                 </MenuItem>
//               ) : (
//                 jobValue?.map((job, index) => (
//                   <MenuItem
//                     key={index}
//                     value={job.jobDescription}
//                     sx={{
//                       whiteSpace: "normal",
//                       wordWrap: "break-word",
//                       padding: "8px 16px",
//                       fontWeight: "400",
//                       fontSize: "14px",
//                       lineHeight: "1.5",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       "&:hover": {
//                         backgroundColor: "rgba(0, 0, 0, 0.08)",
//                       },
//                       "&.Mui-selected": {
//                         backgroundColor: "rgba(0, 0, 0, 0.12)",
//                       },
//                     }}
//                   >
//                     {job.jobDescription}
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       {/* View Mode Toggle */}
//       <Box sx={{
//         mb: 2,
//         display: 'flex',
//         alignItems: 'center',
//         gap: 1,
//         justifyContent: {
//           xs: 'center',
//           sm: 'flex-start'
//         },
//         flexWrap: 'wrap',

//       }}>

//         <ToggleButtonGroup
//           value={viewMode}
//           exclusive
//           onChange={(e, newMode) => newMode && setViewMode(newMode)}
//           size="small"
//           sx={{

//             '& .MuiToggleButton-root': {
//               borderColor: '#154C79',
//               color: '#154C79',
//               textTransform: 'none',

//               '&:hover': {
//                 backgroundColor: 'rgba(21, 76, 121, 0.08)',
//               },

//               '&.Mui-selected': {

//                 backgroundColor: '#154C79',
//                 color: '#fff',
//                 fontWeight: 500,

//                 '&:hover': {
//                   backgroundColor: '#154C79',
//                 }
//               },

//               '&.Mui-focusVisible': {
//                 backgroundColor: '#154C79',
//                 color: '#fff',
//               }
//             }
//           }}
//         >
//           <ToggleButton value="all">All Employees</ToggleButton>
//           {selectedJobIwno && (
//             <ToggleButton value="selected-job">Assigned Emp</ToggleButton>
//           )}
//           <ToggleButton value="unassigned">Other Assigned</ToggleButton>
//           <ToggleButton value="notassigned">Not Assigned</ToggleButton> 
//         </ToggleButtonGroup>
//       </Box>

//       {/* Attendance List */}
//       <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
//         {loading ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               marginTop: "20px",
//             }}
//           >
//       <CircularProgress />
//     </Box>
//   ) : filteredAttendanceItems && filteredAttendanceItems.length > 0 ? (
//     filteredAttendanceItems.map((item) => {
//       console.log("Loading Employee ID:", item.id);
//       const assignedJob = getEmployeeJob(item.iwNo);
//       const isAssignedToSelectedJob = isEmployeeAssignedToSelectedJob(item.iwNo);
//       const isAssignedToOtherJob = assignedJob && !isAssignedToSelectedJob;
//       const isAssignedToAnyJob = isAssignedToSelectedJob || isAssignedToOtherJob;
      
//       // other supervisor
//       const isAssignedByOther = isAssignedByOtherSupervisor(item);

//       return (
//           <Box
//             key={item.id}
//             sx={{
//               padding: "15px",
//               borderRadius: "10px",
//               marginBottom: "10px",
//               boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//               backgroundColor: 
//                 viewMode === "unassigned" ? "#c7c6c6" :
//                 isAssignedToSelectedJob ? "#e8f5e8" :
//                 isAssignedToOtherJob ? "#fff3e0" : 
//                 (viewMode === "all" && item.iwNo > 0) ? "#f5f5f5" : "#fff",
//               border: 
//                 viewMode === "unassigned" ? "1px solid #bdbdbd" :
//                 isAssignedToSelectedJob ? "2px solid #4CAF50" :
//                 isAssignedToOtherJob ? "2px solid #FFA500" : 
//                 (viewMode === "all" && item.iwNo > 0) ? "1px solid #e0e0e0" : "1px solid #ddd",
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//           <img
//             src={`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
//             alt={item.EmpName}
//             style={{
//               width: "50px",
//               height: "50px",
//               borderRadius: "50%",
//               objectFit: "cover",
//               border: "2px solid #ddd",
//               marginRight: "15px",
//             }}
//             onError={(e) => (e.target.src = "/placeholder-image.jpg")}
//           />

//           <Box sx={{ flexGrow: 1, marginLeft: 1 }}>
//             <Typography
//               sx={{
//                 fontWeight: "bold",
//                 color: "#121212",
//                 fontSize: "14px",
//                 marginRight: "10px",
//               }}
//             >
//               {item.EmpName}
//             </Typography>

//             {isAssignedToSelectedJob && (
//               <Typography
//                 sx={{
//                   color: "#4CAF50",
//                   fontSize: "12px",
//                   fontWeight: "normal",
//                 }}
//               >
//                 (Assigned to this job)
//               </Typography>
//             )}
            
//             {isAssignedToOtherJob && (
//               <Typography
//                 sx={{
//                   color: "#FFA500",
//                   fontSize: "12px",
//                   fontWeight: "normal",
//                 }}
//               >
//                 (Assigned to: {assignedJob?.jobDescription})
//               </Typography>
//             )}
            
//             {/* Show supervisor info when in "Other Assigned" view OR when in "All Employees" view and assigned by current user */}
//             {/* {((viewMode === "unassigned" && isAssignedByOther) || 
//               (viewMode === "all" && item.SupervisorServiceNo === employeeId && item.iwNo > 0)) && (
//               <Box sx={{ mt: 0.5 }}>
//                 <Typography
//                   sx={{
//                     color: "#926819",
//                     fontSize: "11px",
//                     fontWeight: "normal",
//                   }}
//                 >
//                   Supervisor: {item.SupervisorName || "N/A"}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     color: "#926819",
//                     fontSize: "11px",
//                     fontWeight: "normal",
//                   }}
//                 >
//                   Job: {item.jobDescription || "N/A"}
//                 </Typography>
//               </Box>
//             )} */}
            
//             {/* -------Dulitha---------- */}
//             {item.iwNo > 0 && (
//               <>
//                 {/* Other supervisor assigned */}
//                 {viewMode === "unassigned" && isAssignedByOther && (
//                   <Box sx={{ mt: 0.5 }}>
//                     <Typography sx={{ color: "#926819", fontSize: "11px" }}>
//                       Supervisor: {item.SupervisorName || "N/A"}
//                     </Typography>
//                     <Typography sx={{ color: "#926819", fontSize: "11px" }}>
//                       Job: {item.jobDescription || "Unassigned"}
//                     </Typography>
//                   </Box>
//                 )}

//                 {/* All employees view */}
//                 {viewMode === "all" && (
//                   <Box sx={{ mt: 0.5 }}>
//                     <Typography sx={{ color: "#926819", fontSize: "11px" }}>
//                       Supervisor: {item.SupervisorName || "N/A"}
//                     </Typography>
//                     <Typography sx={{ color: "#926819", fontSize: "11px" }}>
//                       Job: {item.jobDescription || "Unassigned"}
//                     </Typography>
//                   </Box>
//                 )}
//               </>
//             )}


//             <Typography
//               sx={{
//                 fontWeight: "bold",
//                 color: "#121212",
//                 fontSize: "14px",
//               }}
//             >
//               {item.serviceNo}
//             </Typography>
//           </Box>

//           <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
//             <Typography
//               sx={{
//                 color: "#239B56",
//                 fontWeight: "bold",
//                 fontSize: "14px",
//               }}
//             >
//               {item.inTime || "Available"}
//             </Typography>
//             <Typography
//               sx={{
//                 color: "#E74C3C",
//                 fontWeight: "bold",
//                 fontSize: "14px",
//               }}
//             >
//               {item.outTime || "Available"}
//             </Typography>
//           </Box>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 sx={{ flexGrow: 0, marginLeft: 3 }}
//                 checked={!!selectedAttendance[item.id]}
//                 onChange={() => handleCheckboxChange(item.id, item.iwNo)}
//                 color={isAssignedToOtherJob ? "warning" : "primary"}
//                 disabled={viewMode === "unassigned" && isAssignedByOther}
//               />
//             }
//             label=""
//           />
//         </Box>
//       );
//     })
//   ) : (
//     <Typography
//       variant="body1"
//       sx={{ textAlign: "center", padding: "20px" }}
//     >
//       {
//         viewMode === 'selected-job' && selectedJobIwno
//           ? "No employees assigned to this job."
//           : viewMode === 'unassigned'
//             ? "No employees assigned by other supervisors."
//             : viewMode === 'notassigned'
//               ? "All employees are assigned to jobs."
//               : "No attendance data available."
//       }
//     </Typography>
//   )}
// </Box>
//       {/* Submit Button */}
//       <Box
//         sx={{ display: "flex", justifyContent: "center", marginTop: "20px", gap: 2 }}
//       >
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           disabled={jobAssignmentLoading || selectedCount === 0}
//           sx={{
//             backgroundColor: "#142C54",
//             color: "#fff",
//             fontSize: "1rem",
//             borderRadius: "10px",
//             padding: "10px 20px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//             "&:hover": {
//               backgroundColor: "#0E3C59",
//             },
//             "&:disabled": {
//               backgroundColor: "#cccccc",
//             }
//           }}
//         >
//           {jobAssignmentLoading ? (
//             <CircularProgress size={24} color="inherit" />
//           ) : selectedJobIwno ? (
//             "Assign Job"
//           ) : (
//             "Remove Job"
//           )}
//         </Button>
//       </Box>

//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AssignJob;


//---------------------Dulitha---------------------------

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Checkbox,
  FormControlLabel,
  Button,
  Snackbar,
  Alert,
  TextField,
  InputAdornment,
  Chip,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import HeaderBannerPage from "../components/HeaderBannerPage";
import { fetchTodayAttendance } from "../actions/TodayAction";
import { fetchJobs, fetchLocations, assignJob } from "../actions/AssignAction";
import IwoStatusManage from "./IwoStatusManage";
 
const AssignJob = () => {
  const dispatch = useDispatch();
  const { attendanceItems, loading } = useSelector(
    (state) => state.todayAttendance || {}
  );
  const { jobValue, loading: jobLoading } = useSelector(
    (state) => state.assignJob || {}
  );
  const { locationValue, loading: locationLoading } = useSelector(
    (state) => state.assignLocation || {}
  );
  const { loading: jobAssignmentLoading, error } = useSelector(
    (state) => state.assignJobpost || {}
  );
 
  const [selectedJob, setSelectedJob] = useState("");
  const [selectedJobIwno, setSelectedJobIwno] = useState("");
  const [selectedAttendance, setSelectedAttendance] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState("unassigned");
 
  const location = useLocation();
  const { employeeId, department, role } = location.state || {};
  const [selectedLocation, setSelectedLocation] = useState(role);
 
  const getEmployeeJob = (employeeIwNo) => {
    if (!jobValue || !employeeIwNo || employeeIwNo === 0) return null;
    return jobValue.find(job => job.iwNo === employeeIwNo.toString());
  };
 
  const isEmployeeAssignedToSelectedJob = (employeeIwNo) => {
    if (!employeeIwNo || employeeIwNo === 0 || !selectedJobIwno) return false;
    const assignedJob = getEmployeeJob(employeeIwNo);
    return assignedJob && assignedJob.iwNo === selectedJobIwno;
  };
 
  const isEmployeeAssignedToAnyJob = (employeeIwNo) => {
    if (!employeeIwNo || employeeIwNo === 0) return false;
    return !!getEmployeeJob(employeeIwNo);
  };
  
 const isAssignedByOtherSupervisor = (employee) => {
  return (
    employee?.iwNo !== null &&                 // job assigned
    employee?.SupervisorServiceNo &&           // has supervisor
    employee.SupervisorServiceNo !== employeeId // not logged supervisor
  );
};
  const selectAllEmployeesForJob = () => {
    if (!attendanceItems || attendanceItems.length === 0) {
      setSnackbarMessage("No employees available.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }
 
    if (!selectedJobIwno) {
      setSnackbarMessage("Please select a job first.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }
 
    const updatedSelectedAttendance = { ...selectedAttendance };
 
 
    let employeesToSelect = filteredAttendanceItems;
 
    employeesToSelect.forEach(item => {
      if (!isEmployeeAssignedToSelectedJob(item.iwNo)) {
        updatedSelectedAttendance[item.id] = true;
      }
    });
 
    setSelectedAttendance(updatedSelectedAttendance);
 
    setSnackbarMessage(`Selected ${employeesToSelect.length} employee(s).`);
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  };
 
  const clearAllSelections = () => {
    setSelectedAttendance({});
    setSnackbarMessage("All selections cleared.");
    setSnackbarSeverity("info");
    setSnackbarOpen(true);
  };
 
  //------------Dulitha-----------
const filterEmployeesByJob = (employee) => {
  switch (viewMode) {
    case "selected-job":
      return selectedJobIwno && isEmployeeAssignedToSelectedJob(employee.iwNo);
 
    case "unassigned":
      return (
        employee.iwNo > 0 &&
        employee.SupervisorServiceNo &&
        employee.SupervisorServiceNo !== employeeId
      );
 
    case "notassigned":
      return employee.iwNo === 0;
 
    case "all":
    default:
      return true;
  }
};
 
 
 
  const handleJobChange = (event) => {
    const selectedJobValue = event.target.value;
    if (selectedJobValue) {
      const selectedJobData = jobValue.find(
        (job) => job.jobDescription === selectedJobValue
      );
      if (selectedJobData) {
        setSelectedJob(selectedJobValue);
        setSelectedJobIwno(selectedJobData.iwNo);
 
      }
    } else {
      setSelectedJob("");
      setSelectedJobIwno("");
    }
  };
 
  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
  };
 
  const handleCheckboxChange = (id, employeeIwNo) => {
    setSelectedAttendance((prev) => {
      const updatedState = { ...prev, [id]: !prev[id] };
      return updatedState;
    });
  };
 
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };
 
  useEffect(() => {
    if (employeeId && department) {
      const date = getTodayDate();
      dispatch(fetchTodayAttendance(date, department, selectedLocation));
      dispatch(fetchJobs(date, employeeId));
      dispatch(fetchLocations(department));
    }
  }, [dispatch, selectedLocation, employeeId, department]);
 
  // const handleSubmit = () => {
  //   const selectedEmpIds = Object.keys(selectedAttendance).filter(
  //     (key) => selectedAttendance[key]
      
  //   );
 
  //   if (selectedEmpIds.length === 0) {
  //     setSnackbarMessage("Please select at least one employee.");
  //     setSnackbarSeverity("error");
  //     setSnackbarOpen(true);
  //     return;
  //   }
 
  //   if (!selectedJobIwno) {
 
  //     const atttendJobList = selectedEmpIds.map((id) => {
  //       const employee = attendanceItems.find(item => item.id === parseInt(id));
  //       const employeeIwNo = employee ? employee.iwNo : "0";
  //       return {
  //         Id: id,
  //         iwNo: "0",
  //         supervisorserviceno: employeeId,
  //         employeeIwNo: employeeIwNo
  //       };
  //     });
 
  //     const postData = {
  //       atttendJobList: JSON.stringify(atttendJobList),
  //       supervisor: employeeId,
  //     };
  //     console.log("REMOVE JOB - Selected Emp IDs:", selectedEmpIds);
  //     console.log("REMOVE JOB - Attend Job List:", atttendJobList);
  //     console.log("REMOVE JOB - Final Post Data:", postData);
 
  //     dispatch(assignJob(postData));
  //     setSnackbarMessage("Job removed from selected employees!");
  //     setSnackbarSeverity("success");
  //     setSnackbarOpen(true);
 
  //     setSelectedAttendance({});
  //     return;
  //   }
 
  //   const atttendJobList = selectedEmpIds.map((id) => {
  //     return {
  //       Id: id,
  //       iwNo: selectedJobIwno,
  //       supervisorserviceno: employeeId,
  //     };
  //   });
 
  //   const postData = {
  //     atttendJobList: JSON.stringify(atttendJobList),
  //     supervisor: employeeId,
  //   };
 
  //   dispatch(assignJob(postData));
 
  //   setSelectedAttendance({});
 
  //   setSnackbarMessage("Job assigned successfully!");
  //   setSnackbarSeverity("success");
  //   setSnackbarOpen(true);
  // };
 
  const handleSubmit = () => {
  const selectedEmpIds = Object.keys(selectedAttendance).filter(
    (key) => selectedAttendance[key]
  );
 
  if (selectedEmpIds.length === 0) {
    setSnackbarMessage("Please select at least one employee.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
    return;
  }
 
  if (!selectedJobIwno) {
    // Remove job scenario
    const atttendJobList = selectedEmpIds.map((id) => {
      const employee = attendanceItems.find(item => item.id === parseInt(id));
      const employeeIwNo = employee ? employee.iwNo : "0";
      return {
        Id: id,
        iwNo: "0", // removing job
        supervisorserviceno: employeeId,
        employeeIwNo: employeeIwNo
      };
    });
 
    const postData = {
      atttendJobList: JSON.stringify(atttendJobList),
      supervisor: employeeId,
    };
 
    // ---------- Console logs ----------
    console.log("REMOVE JOB - Selected Employee IDs:", selectedEmpIds);
    console.log("REMOVE JOB - Attend Job List:", atttendJobList);
    console.log("REMOVE JOB - Final Post Data to API:", postData);
    // -----------------------------------
 
    dispatch(assignJob(postData));
 
    setSnackbarMessage("Job removed from selected employees!");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
 
    setSelectedAttendance({});
    return;
  }
 
  // Assign job scenario
  const atttendJobList = selectedEmpIds.map((id) => {
    const employee = attendanceItems.find(item => item.id === parseInt(id));
    return {
      Id: id,
      iwNo: selectedJobIwno,
      supervisorserviceno: employeeId,
      employeeName: employee?.EmpName || "N/A",
      serviceNo: employee?.serviceNo || "N/A"
    };
  });
 
  const postData = {
    atttendJobList: JSON.stringify(atttendJobList),
    supervisor: employeeId,
  };
 
  // ---------- Console logs ----------
  console.log("ASSIGN JOB - Selected Employee IDs:", selectedEmpIds);
  console.log("ASSIGN JOB - Attend Job List:", atttendJobList);
  console.log("ASSIGN JOB - Final Post Data to API:", postData);
  // -----------------------------------
 
  dispatch(assignJob(postData));
 
  setSelectedAttendance({});
  setSnackbarMessage("Job assigned successfully!");
  setSnackbarSeverity("success");
  setSnackbarOpen(true);
};
 
 
  useEffect(() => {
    if (jobAssignmentLoading === false) {
      if (error) {
        setSnackbarMessage(`Error: ${error.message}`);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      } else {
        const date = getTodayDate();
        dispatch(fetchTodayAttendance(date, department, selectedLocation));
        dispatch(fetchJobs(date, employeeId));
        setSelectedAttendance({});
      }
    }
  }, [jobAssignmentLoading, error, dispatch, department, selectedLocation, employeeId]);
 
  const filteredAttendanceItems = (attendanceItems || [])
    .filter((item) =>
      item?.serviceNo?.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .filter(filterEmployeesByJob);
 
  const totalEmployees = attendanceItems?.length || 0;
  const selectedCount = Object.values(selectedAttendance).filter(Boolean).length;
  const assignedToSelectedJobCount = attendanceItems?.filter(item =>
    isEmployeeAssignedToSelectedJob(item.iwNo)
  ).length || 0;
  const unassignedCount = attendanceItems?.filter(item =>
    !isEmployeeAssignedToAnyJob(item.iwNo)
  ).length || 0;
 
 
  //----------Dulitha---------
  const isIwNoNull = (employeeIwNo) => {
  return employeeIwNo === null;
};
 
  // IWO Status tab — shows the IWO cards instead of the attendance list
  const isIwoStatusView = viewMode === "iwostatus";
 
 
  return (
    <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
      <HeaderBannerPage />
 
      {!isIwoStatusView && (
      <>
      {/* Search Bar */}
      <Box sx={{ marginBottom: 2 }}>
        <TextField
          fullWidth
          label="Search by Service Number"
          variant="outlined"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#154C79" }} />
              </InputAdornment>
            ),
          }}
          sx={{
            fontSize: { xs: "0.85rem", sm: "1rem" },
            color: "#154C79",
            borderRadius: "20px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "20px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#154C79",
            },
          }}
        />
      </Box>
 
      {/* Stats and Quick Actions Bar */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        flexWrap: 'wrap',
        gap: 1
      }}>
        {/* <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip 
            label={`Total Employees: ${totalEmployees}`} 
            color="primary" 
            variant="outlined" 
          />
          <Chip 
            label={`Selected: ${selectedCount}`} 
            color={selectedCount > 0 ? "primary" : "default"}
            variant={selectedCount > 0 ? "filled" : "outlined"}
          />
          <Chip 
            label={`Assigned to this Job: ${assignedToSelectedJobCount}`} 
            color="success" 
            variant="outlined" 
          />
          <Chip 
            label={`Unassigned: ${unassignedCount}`} 
            color="warning" 
            variant="outlined" 
          />
        </Box> */}
 
        {/* <Box sx={{ display: 'flex', gap: 1 }}>
          <Tooltip title="Select All Employees">
            <IconButton 
              onClick={selectAllEmployeesForJob}
              disabled={!selectedJobIwno}
              sx={{ 
                color: selectedJobIwno ? '#154C79' : '#ccc',
                border: '1px solid',
                borderColor: selectedJobIwno ? '#154C79' : '#ccc'
              }}
            >
              <SelectAllIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Clear All Selections">
            <IconButton 
              onClick={clearAllSelections}
              disabled={selectedCount === 0}
              sx={{ 
                color: selectedCount > 0 ? '#154C79' : '#ccc',
                border: '1px solid',
                borderColor: selectedCount > 0 ? '#154C79' : '#ccc'
              }}
            >
              <ClearAllIcon />
            </IconButton>
          </Tooltip>
        </Box> */}
      </Box>
 
      {/* Location and Job Dropdowns */}
      <Grid container spacing={2} sx={{ marginBottom: 3 }}>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel
              sx={{
                fontSize: { xs: "0.85rem", sm: "1rem" },
                color: "#154C79",
              }}
            >
              Location
            </InputLabel>
            <Select
              value={selectedLocation}
              onChange={handleLocationChange}
              label="Location"
              sx={{
                fontSize: { xs: "0.85rem", sm: "1rem" },
                borderRadius: "20px",
                backgroundColor: "#F0F4F8",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                "& .MuiSelect-icon": {
                  color: "#154C79",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#154C79",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 250,
                    overflowY: "auto",
                  },
                },
              }}
            >
              {locationLoading ? (
                <MenuItem value="">
                  <em>Loading...</em>
                </MenuItem>
              ) : (
                locationValue?.map((location, index) => (
                  <MenuItem
                    key={index}
                    value={location.location}
                    sx={{
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      padding: "8px 16px",
                      fontWeight: "400",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.08)",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "rgba(0, 0, 0, 0.12)",
                      },
                    }}
                  >
                    {location.locationDescription}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
        </Grid>
 
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel
              sx={{
                fontSize: { xs: "0.85rem", sm: "1rem" },
                color: "#154C79",
              }}
            >
              Job
            </InputLabel>
            <Select
              value={selectedJob}
              onChange={handleJobChange}
              label="Job"
              sx={{
                fontSize: { xs: "0.85rem", sm: "1rem" },
                borderRadius: "20px",
                backgroundColor: "#F0F4F8",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                "& .MuiSelect-icon": {
                  color: "#154C79",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#154C79",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 250,
                    overflowY: "auto",
                  },
                },
              }}
            >
              <MenuItem value="">
                <em>Select a Job / Remove Job</em>
              </MenuItem>
              {jobLoading ? (
                <MenuItem value="">
                  <em>Loading...</em>
                </MenuItem>
              ) : (
                jobValue?.map((job, index) => (
                  <MenuItem
                    key={index}
                    value={job.jobDescription}
                    sx={{
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      padding: "8px 16px",
                      fontWeight: "400",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.08)",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "rgba(0, 0, 0, 0.12)",
                      },
                    }}
                  >
                    {job.jobDescription}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      </>
      )}
 
      {/* View Mode Toggle */}
      <Box sx={{
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        justifyContent: {
          xs: 'center',
          sm: 'flex-start'
        },
        flexWrap: 'wrap',
 
      }}>
 
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={(e, newMode) => newMode && setViewMode(newMode)}
          size="small"
          sx={{
 
            '& .MuiToggleButton-root': {
              borderColor: '#154C79',
              color: '#154C79',
              textTransform: 'none',
 
              '&:hover': {
                backgroundColor: 'rgba(21, 76, 121, 0.08)',
              },
 
              '&.Mui-selected': {
 
                backgroundColor: '#154C79',
                color: '#fff',
                fontWeight: 500,
 
                '&:hover': {
                  backgroundColor: '#154C79',
                }
              },
 
              '&.Mui-focusVisible': {
                backgroundColor: '#154C79',
                color: '#fff',
              }
            }
          }}
        >
          <ToggleButton value="all">All Employees</ToggleButton>
          {selectedJobIwno && (
            <ToggleButton value="selected-job">Assigned Emp</ToggleButton>
          )}
          <ToggleButton value="unassigned">Other Assigned</ToggleButton>
          <ToggleButton value="notassigned">Not Assigned</ToggleButton> 
          <ToggleButton value="iwostatus">IWO Status</ToggleButton>
        </ToggleButtonGroup>
      </Box>
 
      {/* IWO Status tab */}
      {isIwoStatusView && <IwoStatusManage serviceNo={employeeId} />}
 
      {/* Attendance List */}
      {!isIwoStatusView && (
      <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
      <CircularProgress />
    </Box>
  ) : filteredAttendanceItems && filteredAttendanceItems.length > 0 ? (
    filteredAttendanceItems.map((item) => {
      console.log("Loading Employee ID:", item.id);
      const assignedJob = getEmployeeJob(item.iwNo);
      const isAssignedToSelectedJob = isEmployeeAssignedToSelectedJob(item.iwNo);
      const isAssignedToOtherJob = assignedJob && !isAssignedToSelectedJob;
      const isAssignedToAnyJob = isAssignedToSelectedJob || isAssignedToOtherJob;
      
      // other supervisor
      const isAssignedByOther = isAssignedByOtherSupervisor(item);
 
      return (
          <Box
            key={item.id}
            sx={{
              padding: "15px",
              borderRadius: "10px",
              marginBottom: "10px",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              backgroundColor: 
                viewMode === "unassigned" ? "#c7c6c6" :
                isAssignedToSelectedJob ? "#e8f5e8" :
                isAssignedToOtherJob ? "#fff3e0" : 
                (viewMode === "all" && item.iwNo > 0) ? "#f5f5f5" : "#fff",
              border: 
                viewMode === "unassigned" ? "1px solid #bdbdbd" :
                isAssignedToSelectedJob ? "2px solid #4CAF50" :
                isAssignedToOtherJob ? "2px solid #FFA500" : 
                (viewMode === "all" && item.iwNo > 0) ? "1px solid #e0e0e0" : "1px solid #ddd",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
          <img
            src={`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
            alt={item.EmpName}
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #ddd",
              marginRight: "15px",
            }}
            onError={(e) => (e.target.src = "/placeholder-image.jpg")}
          />
 
          <Box sx={{ flexGrow: 1, marginLeft: 1 }}>
            <Typography
              sx={{
                fontWeight: "bold",
                color: "#121212",
                fontSize: "14px",
                marginRight: "10px",
              }}
            >
              {item.EmpName}
            </Typography>
 
            {isAssignedToSelectedJob && (
              <Typography
                sx={{
                  color: "#4CAF50",
                  fontSize: "12px",
                  fontWeight: "normal",
                }}
              >
                (Assigned to this job)
              </Typography>
            )}
            
            {isAssignedToOtherJob && (
              <Typography
                sx={{
                  color: "#FFA500",
                  fontSize: "12px",
                  fontWeight: "normal",
                }}
              >
                (Assigned to: {assignedJob?.jobDescription})
              </Typography>
            )}
            
            {/* Show supervisor info when in "Other Assigned" view OR when in "All Employees" view and assigned by current user */}
            {/* {((viewMode === "unassigned" && isAssignedByOther) || 
              (viewMode === "all" && item.SupervisorServiceNo === employeeId && item.iwNo > 0)) && (
              <Box sx={{ mt: 0.5 }}>
                <Typography
                  sx={{
                    color: "#926819",
                    fontSize: "11px",
                    fontWeight: "normal",
                  }}
                >
                  Supervisor: {item.SupervisorName || "N/A"}
                </Typography>
                <Typography
                  sx={{
                    color: "#926819",
                    fontSize: "11px",
                    fontWeight: "normal",
                  }}
                >
                  Job: {item.jobDescription || "N/A"}
                </Typography>
              </Box>
            )} */}
            
            {/* -------Dulitha---------- */}
            {item.iwNo > 0 && (
              <>
                {/* Other supervisor assigned */}
                {viewMode === "unassigned" && isAssignedByOther && (
                  <Box sx={{ mt: 0.5 }}>
                    <Typography sx={{ color: "#926819", fontSize: "11px" }}>
                      Supervisor: {item.SupervisorName || "N/A"}
                    </Typography>
                    <Typography sx={{ color: "#926819", fontSize: "11px" }}>
                      Job: {item.jobDescription || "Unassigned"}
                    </Typography>
                  </Box>
                )}
 
                {/* All employees view */}
                {viewMode === "all" && (
                  <Box sx={{ mt: 0.5 }}>
                    <Typography sx={{ color: "#926819", fontSize: "11px" }}>
                      Supervisor: {item.SupervisorName || "N/A"}
                    </Typography>
                    <Typography sx={{ color: "#926819", fontSize: "11px" }}>
                      Job: {item.jobDescription || "Unassigned"}
                    </Typography>
                  </Box>
                )}
              </>
            )}
 
 
            <Typography
              sx={{
                fontWeight: "bold",
                color: "#121212",
                fontSize: "14px",
              }}
            >
              {item.serviceNo}
            </Typography>
          </Box>
 
          <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
            <Typography
              sx={{
                color: "#239B56",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {item.inTime || "Available"}
            </Typography>
            <Typography
              sx={{
                color: "#E74C3C",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {item.outTime || "Available"}
            </Typography>
          </Box>
          <FormControlLabel
            control={
              <Checkbox
                sx={{ flexGrow: 0, marginLeft: 3 }}
                checked={!!selectedAttendance[item.id]}
                onChange={() => handleCheckboxChange(item.id, item.iwNo)}
                color={isAssignedToOtherJob ? "warning" : "primary"}
                disabled={viewMode === "unassigned" && isAssignedByOther}
              />
            }
            label=""
          />
        </Box>
      );
    })
  ) : (
    <Typography
      variant="body1"
      sx={{ textAlign: "center", padding: "20px" }}
    >
      {
        viewMode === 'selected-job' && selectedJobIwno
          ? "No employees assigned to this job."
          : viewMode === 'unassigned'
            ? "No employees assigned by other supervisors."
            : viewMode === 'notassigned'
              ? "All employees are assigned to jobs."
              : "No attendance data available."
      }
    </Typography>
  )}
</Box>
      )}
      {/* Submit Button */}
      {!isIwoStatusView && (
      <Box
        sx={{ display: "flex", justifyContent: "center", marginTop: "20px", gap: 2 }}
      >
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={jobAssignmentLoading || selectedCount === 0}
          sx={{
            backgroundColor: "#142C54",
            color: "#fff",
            fontSize: "1rem",
            borderRadius: "10px",
            padding: "10px 20px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              backgroundColor: "#0E3C59",
            },
            "&:disabled": {
              backgroundColor: "#cccccc",
            }
          }}
        >
          {jobAssignmentLoading ? (
            <CircularProgress size={24} color="inherit" />
          ) : selectedJobIwno ? (
            "Assign Job"
          ) : (
            "Remove Job"
          )}
        </Button>
      </Box>
      )}
 
      {/* Snackbar Notification */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};
 
export default AssignJob;